import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import stylesheet from './SVG.module.css';
export { IllustrationBikeOnPath } from './IllustrationBikeOnPath.js';
export { IllustrationCelebration } from './IllustrationCelebration.js';
export { IllustrationLargeGroup } from './IllustrationLargeGroup.js';
export { IllustrationManOnLadder } from './IllustrationManOnLadder.js';
export { IllustrationManOnPhone } from './IllustrationManOnPhone.js';
export { IllustrationMoreNextSteps } from './IllustrationMoreNextSteps.js';
export { IllustrationNewWay } from './IllustrationNewWay.js';
export { IllustrationOldWay } from './IllustrationOldWay.js';
export { IllustrationWebsiteEditing } from './IllustrationWebsiteEditing.js';
export { IllustrationWomanAtKiosk } from './IllustrationWomanAtKiosk.js';
export { IllustrationWomanOnPhone } from './IllustrationWomanOnPhone.js';

export function SVG(props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/SVG" {...props}>
      {props.children}
    </svg>
  );
}

export class UniqueComponent extends Component {
  constructor(props) {
    super(props);
    this.token = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '');
  }

  uniqueName = name => {
    return `${name}-${this.token}`;
  };

  uniqueId = name => {
    return `#${this.uniqueName(name)}`;
  };

  uniqueUrl = name => {
    return `url(${this.uniqueId(name)})`;
  };
}

export function SVGDefs(props) {
  return (
    <SVG
      {...props}
      style={{
        width: 0,
        height: 0,
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
      }}
    >
      <defs>
        <path
          id="logo-path"
          fillRule="evenodd"
          d="M33.696 14.357c.843.192 1.949-.983 3.318-3.527.6-1.112.725-3.28.836-4.518.064-.723.07-.637.17-1.297.032-.216.1-.462.206-.738C38.997 1.797 41.279 0 43.973 0 47.302 0 50 2.743 50 6.126c0 3.002-2.124 5.5-4.928 6.025-1.687.441-3.648.681-5.073 1.73-2.177 1.6-3.018 2.901-2.524 3.902a21.904 21.904 0 0 1 5.382 14.435C42.857 44.248 33.263 54 21.429 54 9.594 54 0 44.248 0 32.218s9.594-21.781 21.429-21.781a21.1 21.1 0 0 1 12.267 3.92zM21.684 32.174l8.908 8.818V23.355h-3.678v8.819h-5.23zm-.285 0l-8.908-8.819v17.637h3.677v-8.818h5.231z"
        />

        <linearGradient
          id="white-to-gray"
          x1="50%"
          x2="50%"
          y1="16.41%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#F3F5F7" />
        </linearGradient>

        <linearGradient
          id="logo-gradient"
          y2="125.366%"
          x2="119.392%"
          y1="24.664%"
          x1="9.424%"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" stopColor="#D06BF2" />
          <stop offset="100%" stopColor="#3B96E5" />
        </linearGradient>

        <filter
          x="0"
          y="0"
          width="51"
          height="56"
          filterUnits="objectBoundingBox"
          id="logo-shadow"
        >
          <feOffset dx="1" dy="2" in="SourceAlpha" result="offset1" />
          <feFlood
            x="0"
            y="0"
            width="51"
            height="56"
            floodColor="#875EC7"
            floodOpacity="0.5"
            in="offset1"
            result="flooded"
          />
          <feComposite
            in="flooded"
            in2="offset1"
            operator="in"
            result="shadow-clipped"
          />
        </filter>
      </defs>
    </SVG>
  );
}

export function LogoWhite(props) {
  return (
    <SVG viewBox="0 0 51 56">
      <use fill="#ffffff" href="#logo-path" xlinkHref="#logo-path" />
    </SVG>
  );
}

export function LogoWhiteWithShadow(props) {
  return (
    <SVG viewBox="0 0 51 56">
      <use
        filter="url(#logo-shadow)"
        href="#logo-path"
        xlinkHref="#logo-path"
      />
      <use fill="#ffffff" href="#logo-path" xlinkHref="#logo-path" />
    </SVG>
  );
}

export function LogoColor(props) {
  return (
    <SVG {...props} viewBox="0 0 51 56">
      <use
        fill="url(#logo-gradient)"
        href="#logo-path"
        xlinkHref="#logo-path"
      />
    </SVG>
  );
}

export function IconFacebook(props) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        d="M0 16c0-2.17.42-4.24 1.27-6.22a15.98 15.98 0 0 1 3.41-5.1A16.17 16.17 0 0 1 16 0c2.17 0 4.24.42 6.22 1.27 1.97.84 3.68 1.98 5.1 3.4a16.05 16.05 0 0 1 3.41 5.11A15.67 15.67 0 0 1 32 16c0 2.17-.42 4.24-1.27 6.22a16.05 16.05 0 0 1-3.4 5.1 16.05 16.05 0 0 1-5.11 3.41A15.67 15.67 0 0 1 16 32a16.17 16.17 0 0 1-11.32-4.67 15.98 15.98 0 0 1-3.41-5.11A15.67 15.67 0 0 1 0 16zm11.98 0h1.79v8.63h3.56V16h2.4l.3-2.98h-2.68v-1.5c0-.45.07-.76.2-.93.13-.17.46-.26.98-.26h1.49V7.35h-2.39c-1.39 0-2.38.33-2.97.98-.6.66-.9 1.63-.9 2.9v1.79h-1.78V16z"
        fillRule="evenodd"
      />
    </SVG>
  );
}

export function IconInstagram(props) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g>
        <path d="M16 12.66a3.34 3.34 0 1 0 0 6.68 3.34 3.34 0 0 0 0-6.68zm5.23-1.46c0 .58-.86.58-.86 0s.86-.58.86 0" />
        <path d="M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0zm9.14 18.88a6.27 6.27 0 0 1-6.26 6.26h-5.76a6.27 6.27 0 0 1-6.26-6.26v-5.76a6.27 6.27 0 0 1 6.26-6.26h5.76a6.27 6.27 0 0 1 6.26 6.26v5.76z" />
        <path d="M18.88 8.17h-5.76a4.96 4.96 0 0 0-4.95 4.95v5.76a4.96 4.96 0 0 0 4.95 4.95h5.76a4.96 4.96 0 0 0 4.95-4.95v-5.76a4.96 4.96 0 0 0-4.95-4.95zM16 20.65a4.65 4.65 0 1 1 .01-9.3 4.65 4.65 0 0 1-.01 9.3zm4.8-7.7a1.74 1.74 0 1 1 0-3.5 1.74 1.74 0 0 1 0 3.5z" />
      </g>
    </SVG>
  );
}

export function IconTwitter(props) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        d="M0 16c0-2.17.42-4.24 1.27-6.22a16.05 16.05 0 0 1 3.4-5.1 16.05 16.05 0 0 1 5.11-3.41A15.67 15.67 0 0 1 16 0c2.17 0 4.24.42 6.22 1.27 1.97.84 3.68 1.98 5.1 3.4a16.05 16.05 0 0 1 3.41 5.11A15.67 15.67 0 0 1 32 16c0 2.17-.42 4.24-1.27 6.22a16.05 16.05 0 0 1-3.4 5.1 16.05 16.05 0 0 1-5.11 3.41A15.67 15.67 0 0 1 16 32c-2.17 0-4.24-.42-6.22-1.27a16.05 16.05 0 0 1-5.1-3.4 16.05 16.05 0 0 1-3.41-5.11A15.67 15.67 0 0 1 0 16zm6.48 6.8c0 .11.05.2.15.27a11.33 11.33 0 0 0 6.13 1.8c2.3 0 4.36-.59 6.2-1.75a10.86 10.86 0 0 0 4-4.53 11.99 11.99 0 0 0 1.21-5.11v-.36a6.69 6.69 0 0 0 1.86-1.99.34.34 0 0 0 .07-.18.33.33 0 0 0-.1-.24.33.33 0 0 0-.25-.11l-.25.08a7 7 0 0 1-.75.29c.19-.23.38-.5.56-.84.18-.33.27-.57.27-.73a.3.3 0 0 0-.1-.22.35.35 0 0 0-.25-.1c-.04 0-.1.01-.16.04-.83.44-1.55.74-2.19.88a4.1 4.1 0 0 0-2.96-1.2 4.1 4.1 0 0 0-2.99 1.23 4.06 4.06 0 0 0-1.2 3.5 10.43 10.43 0 0 1-6.18-2.7c-.31-.3-.7-.7-1.17-1.2a.36.36 0 0 0-.28-.13c-.12 0-.2.06-.25.17-.4.55-.6 1.26-.6 2.13 0 1 .33 1.89.98 2.67l-.33-.14a.9.9 0 0 0-.35-.11.4.4 0 0 0-.28.1.33.33 0 0 0-.12.26 4.33 4.33 0 0 0 2.03 3.6h-.05a.19.19 0 0 0-.08-.01.43.43 0 0 0-.13-.02.33.33 0 0 0-.24.1.3.3 0 0 0-.1.22l.04.11a4.22 4.22 0 0 0 3.03 2.82 7.26 7.26 0 0 1-4.85 1.05c-.08 0-.15.04-.22.1a.35.35 0 0 0-.1.25z"
        fillRule="evenodd"
      />
    </SVG>
  );
}

export function IconYouTube(props) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        d="M0 16c0-2.17.42-4.24 1.27-6.22a16.05 16.05 0 0 1 3.4-5.1 16.05 16.05 0 0 1 5.11-3.41A15.67 15.67 0 0 1 16 0c2.17 0 4.24.42 6.22 1.27 1.97.84 3.68 1.98 5.1 3.4a16.05 16.05 0 0 1 3.41 5.11A15.67 15.67 0 0 1 32 16c0 2.17-.42 4.24-1.27 6.22a16.05 16.05 0 0 1-3.4 5.1 16.05 16.05 0 0 1-5.11 3.41A15.67 15.67 0 0 1 16 32c-2.17 0-4.24-.42-6.22-1.27a16.05 16.05 0 0 1-5.1-3.4 16.05 16.05 0 0 1-3.41-5.11A15.67 15.67 0 0 1 0 16zm22.62-7H9.38A3.4 3.4 0 0 0 6 12.42v7.16A3.4 3.4 0 0 0 9.38 23h13.24A3.4 3.4 0 0 0 26 19.58v-7.16A3.4 3.4 0 0 0 22.62 9zm-2.87 7.4l-6.07 3.05a.48.48 0 0 1-.46-.02.45.45 0 0 1-.22-.39v-6.08a.5.5 0 0 1 .22-.4.48.48 0 0 1 .46 0l6.07 3.04a.45.45 0 0 1 0 .8z"
        fillRule="evenodd"
      />
    </SVG>
  );
}

export function IconDocument(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 88 68">
      <path
        d="M6.13 0A6.16 6.16 0 0 0 0 6.13v55.74A6.16 6.16 0 0 0 6.13 68h55.74A6.16 6.16 0 0 0 68 61.87V43.84l19.4-19.37a2 2 0 0 0 0-2.81l-9.06-9.07a2 2 0 0 0-1.62-.59 2 2 0 0 0-1.19.6L68 20.15V6.13A6.16 6.16 0 0 0 61.69 0a2 2 0 1 0 .19 4c1.2 0 2.12.91 2.12 2.13v18.03L46.6 41.59A2 2 0 0 0 46 43v9c0 1.1.9 2 2 2h9a2 2 0 0 0 1.4-.6l5.6-5.59v14.07c0 1.21-.91 2.12-2.12 2.12H6.13A2.07 2.07 0 0 1 4 61.88V6.13C4 4.9 4.91 4 6.13 4H54a2 2 0 0 0 2.03-2A2 2 0 0 0 54 0H6.12zm7.68 14a2 2 0 1 0 .19 4h40a2 2 0 0 0 2.03-2A2 2 0 0 0 54 14H13.81zm63.13 2.81l6.25 6.25-3.66 3.66-6.25-6.25 3.66-3.66zm-6.47 6.47l6.25 6.25L56.19 50H50v-6.19l20.47-20.53zM13.8 26a2 2 0 1 0 .19 4h40a2 2 0 0 0 2.03-2A2 2 0 0 0 54 26H13.81zm0 12a2 2 0 1 0 .19 4h26.16a2 2 0 0 0 2.02-2c0-.54-.21-1.05-.59-1.43a2 2 0 0 0-1.43-.57H13.8zm0 12a2 2 0 1 0 .19 4h26a2 2 0 0 0 2.03-2A2 2 0 0 0 40 50H13.81z"
        fill={color}
      />
    </SVG>
  );
}
IconDocument.propTypes = {
  color: PropTypes.string,
};
IconDocument.defaultProps = {
  color: 'currentColor',
};

export function IconVideo(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 257 199">
      <path
        d="M0 0v154.06h257V0H0zm12.85 12.84h231.3v128.39H12.85V12.83zM102.3 31.9c-3.16.25-5.87 3.32-5.82 6.62v77.03c.03 4.54 5.64 7.87 9.43 5.61l64.25-38.51c3.82-2.28 3.82-9.05 0-11.34L105.91 32.8a6.13 6.13 0 0 0-3.61-.9zm6.83 17.95l45.27 27.18-45.27 27.08V49.85zM48.19 166.9a16.03 16.03 0 0 0-14.66 9.63H19.27a6.42 6.42 0 1 0 0 12.84h14.26A16.03 16.03 0 0 0 48.19 199c6.57 0 12.17-3.99 14.65-9.63h174.89a6.42 6.42 0 1 0 0-12.84H62.84a16.03 16.03 0 0 0-14.65-9.63z"
        fill={color}
      />
    </SVG>
  );
}
IconVideo.propTypes = {
  color: PropTypes.string,
};
IconVideo.defaultProps = {
  color: 'currentColor',
};

export function IconPlaylist(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 79 69">
      <path
        d="M0 13h79v56H0V13zm3 3h72v49H3V16zM13 0h53v3H13V0zM7 7h66v3H7V7zm23 23l23 11.5L30 53V30z"
        fillRule="evenodd"
        fill={color}
      />
    </SVG>
  );
}
IconPlaylist.propTypes = {
  color: PropTypes.string,
};
IconPlaylist.defaultProps = {
  color: 'currentColor',
};

export function IconCheckMark(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 21 16">
      <path
        d="M2 7.25L7.75 13 19 1.5"
        fill="none"
        stroke={color}
        strokeWidth="4"
      />
    </SVG>
  );
}
IconCheckMark.propTypes = {
  color: PropTypes.string,
};
IconCheckMark.defaultProps = {
  color: 'currentColor',
};

export function IconEye(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 74 46">
      <g fill={color}>
        <path d="M37 9.32c.67 0 1.1-.45 1.1-1.11V1.42c0-.66-.44-1.1-1.1-1.1-.67 0-1.1.44-1.1 1.1v6.9c0 .55.43 1 1.1 1zm21.54 6.45l6.22-4.9c.45-.33.56-1.1.22-1.55-.33-.45-1.1-.56-1.55-.22l-6.22 4.89c-.44.33-.55 1.1-.22 1.55.33.56 1 .56 1.55.23zm-43.08 0c.44.33 1.22.33 1.55-.23.33-.44.33-1.22-.22-1.55l-6.22-4.9c-.44-.33-1.22-.33-1.55.23-.34.55-.34 1.22.22 1.56l6.22 4.89zM48 10.99c.55.33 1.21.1 1.55-.45l3.44-6.34c.33-.55.11-1.22-.45-1.55-.55-.34-1.22-.12-1.55.44l-3.44 6.34c-.33.56-.11 1.22.44 1.56zM1.35 20.55l8.11 2.67c.56.22 1.22-.11 1.44-.67.23-.56-.1-1.22-.66-1.44l-8.1-2.67c-.56-.23-1.23.1-1.45.66-.22.56.1 1.23.66 1.45zm61.97 2.22c.22.56.78.89 1.44.78L72.98 21c.55-.22.88-.78.78-1.44a1.28 1.28 0 0 0-1.45-.78l-8.21 2.56c-.67.22-1 .89-.78 1.44zM25 10.43c.34.55 1 .78 1.56.44.56-.33.78-1 .45-1.55l-3.33-6.34c-.34-.56-1-.78-1.56-.45-.55.34-.78 1-.44 1.56L25 10.43zm12 5.67c-15.88 0-28.54 13.56-29.1 14.12a1.07 1.07 0 0 0 0 1.56c.56.56 13.22 14.12 29.1 14.12s28.54-13.56 29.1-14.12c.44-.45.44-1.11 0-1.56-.56-.55-13.22-14.12-29.1-14.12zm0 27.58C30 43.68 24.34 38 24.34 31a12.66 12.66 0 1 1 25.32 0c0 7-5.66 12.68-12.66 12.68zM26.67 20.33a14.78 14.78 0 0 0 0 21.34c-8.1-3-14.32-8.67-16.32-10.67 2-2 8.22-7.67 16.32-10.67zm20.66 21.34a14.78 14.78 0 0 0 0-21.34c8.1 3 14.32 8.67 16.32 10.67-2 2-8.22 7.67-16.32 10.67z" />
        <path d="M37 22.55a8.44 8.44 0 1 0 0 16.88 8.44 8.44 0 0 0 0-16.88zm0 14.68A6.21 6.21 0 0 1 30.78 31a6.21 6.21 0 1 1 12.44 0A6.21 6.21 0 0 1 37 37.23z" />
      </g>
    </SVG>
  );
}
IconEye.propTypes = {
  color: PropTypes.string,
};
IconEye.defaultProps = {
  color: 'currentColor',
};

export function IconPlaybook(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 86 98">
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <path d="M74.73 10.94V9.63a9.25 9.25 0 0 0-3.57-6.78 9.52 9.52 0 0 0-4.91-2l-.9-.06h-.7A823.2 823.2 0 0 0 39.53.44c-4.37 0-8.75 0-13 .1L25 .55c-.67 0-1.34.04-2 .14a9.83 9.83 0 0 0-8.28 9.76v1.42l.1 2.7.24 5c.14 2.5.3 4.72.48 6.62a8.9 8.9 0 0 0-8.4 7.08l-.7 2.88-1.38 5.72-2.52 11.07-1.17 5.23a11.96 11.96 0 0 0-.42 3.1c.07.92.19 1.82.37 2.72.54 3.21 1.07 6.24 1.56 8.84a14.4 14.4 0 0 1-.29 6.28c-.08.3.42.79 1.12 1.06.7.27 1.23.2 1.38-.11a15.37 15.37 0 0 0 1.44-7.65 420.4 420.4 0 0 0-.79-9c-.1-.73-.15-1.46-.17-2.19.06-.65.2-1.29.43-1.9l1.42-5.16 2.92-11 1.47-5.7.73-2.87.1-.35c0-.15 0-.15.06-.22a3.2 3.2 0 0 1 .57-1.08 3.48 3.48 0 0 1 6.2 1.76c.05.67-.01 1.35-.2 2l-1 5.47c-.65 3.57-1.25 7-1.79 10.16v.12a2.2 2.2 0 0 0 .67 2 25.5 25.5 0 0 1 3.1 3.76h-.01a26.49 26.49 0 0 1 2.14 3.85c.96 2.14 1.6 4.41 1.89 6.74 0 .33.73.59 1.5.57.77-.02 1.23-.3 1.25-.65a21.7 21.7 0 0 0-1.11-8 27.14 27.14 0 0 0-4.68-8.51c.67-2.83 1.35-5.83 2.05-9l1.2-5.42.14-.7.08-.42.08-.49a8.86 8.86 0 0 0-6.21-9.66c.2-2 .36-4.33.51-7l.24-5 .1-2.7.05-1.36a5 5 0 0 1 4.31-4.6c.51-.08 1.74-.01 2.77-.01a944.52 944.52 0 0 0 38.14-.25h1.23a5.05 5.05 0 0 1 2.65.84 5.35 5.35 0 0 1 2.4 3.59c0 .29.07.51.1.92l.12 2.04.22 2.62c-.35.25-.69.52-1 .82l-2.27 2.3a8.52 8.52 0 0 0-2.23 4 8.25 8.25 0 0 0 2.23 7.9c.65.65 1.4 1.17 2.24 1.54l-.66.47-.84.63a5.8 5.8 0 0 0-.5.43 7.75 7.75 0 0 0-2.23 7.21 8.23 8.23 0 0 0 3.9 5.39l-.33.25-.84.63a5.8 5.8 0 0 0-.5.43 7.74 7.74 0 0 0-2.23 7.2 8.2 8.2 0 0 0 3.16 4.91l-.94.84c-.15.13-.45.44-.7.7h.01a9.03 9.03 0 0 0-1.67 2.87 8.42 8.42 0 0 0 2.05 8.65 8.67 8.67 0 0 0 3.13 2c-.1.66-.18 1.5-.3 2h-.01a5.73 5.73 0 0 1-2.07 3.12A5.2 5.2 0 0 1 66 80.95h-1.34c-2.17-.06-4.42-.1-6.66-.1-9 0-17.95.46-22.41 1.39-.16 0-.28.7-.27 1.47.01.77.13 1.25.27 1.28 3.57.74 10 1.18 17.05 1.32l-.36.36c-1.06 1-2.27 2.18-3.55 3.22a52.4 52.4 0 0 1-3.88 2.82c-1.08.67-2.12 1.4-3.11 2.21.03.47.11.93.26 1.37.07.4.2.8.41 1.17 1.5.2 3.02.04 4.45-.46a16.64 16.64 0 0 0 9.3-7.51c.57-1 1-2.07 1.24-3.18h.6c2.24 0 4.49 0 6.66-.1h.8c.36 0 .73 0 1.09-.07a9.53 9.53 0 0 0 8.2-8.96c0-.65-.05-1.29-.15-1.92a8.64 8.64 0 0 0 2.11-.4 8.4 8.4 0 0 0 2.87-1.67c.25-.24.57-.54.7-.7l2-2.16.28-.32.3-.38a8.08 8.08 0 0 0 1.27-2.5c.34-1.08.42-2.2.25-3.32a6.75 6.75 0 0 0-2.49-4.37h-.24a.25.25 0 0 0 0-.22 5.05 5.05 0 0 0-.53-.63l-.26-.26 1.74-1.76a8.51 8.51 0 0 0 2.23-4 8.26 8.26 0 0 0-2.23-7.91 7.39 7.39 0 0 0-1.13-.9l1.13-1.15a8.51 8.51 0 0 0 2.23-4 8.26 8.26 0 0 0-2.23-7.91 7.64 7.64 0 0 0-2.24-1.53l.66-.47.84-.63c.18-.13.34-.28.5-.43a7.74 7.74 0 0 0 2.23-7.21 8.26 8.26 0 0 0-10.03-6.33c0-.39.07-.78.1-1.2l.07-1.96zM72.9 32.83c.3.25.54.4.6.37.32-.16.66-.3 1-.4h.23c.27-.03.54-.09.8-.16a4.1 4.1 0 0 1 3.55 1.5c.71.92.93 2.13.58 3.23-.18.56-.5 1.07-.94 1.47l-2.3 2.27a3.35 3.35 0 0 1-3.19.86 3.55 3.55 0 0 1-2.42-2.22 4 4 0 0 1 .64-3.9l.65-.85c.4-.54.75-1 1-1.51.05-.08-.1-.35-.36-.67h.16zm6.17 15.22a3.5 3.5 0 0 1-.36 4.69L76.42 55a3.36 3.36 0 0 1-3.19.86 3.56 3.56 0 0 1-2.42-2.22 4.02 4.02 0 0 1 .64-3.88l.63-.84c.4-.54.75-1 1-1.51a8.2 8.2 0 0 0 4.32-.51c.65.22 1.23.62 1.67 1.15zm1.57 12.2c-.48.5-.8 1-.77 1.05a5 5 0 0 1 .57 2.78 4.1 4.1 0 0 1-.9 2.2l-.29.31-.36.33-2.17 2c-.22.2-.28.23-.41.34l-.36.23a3.31 3.31 0 0 1-4.25-4.84c.1-.14.22-.28.34-.41L74 62l.32-.36.29-.27a7.83 7.83 0 0 0 3.5-.87h.26c.23.05.46.12.68.2l.32.13c.1 0 0 0 .1-.08.41-.25.85-.45 1.31-.59l-.14.09zM77.51 19.5a3.54 3.54 0 0 1 2.42 2.22 4 4 0 0 1-.66 3.9l-.63.83c-.4.54-.75 1-1 1.51-.05.08.1.35.36.67h-.11c-.3-.25-.54-.4-.6-.37-.32.16-.65.3-1 .39h-.23c-.27.04-.54.1-.8.17a3.98 3.98 0 0 1-3.55-1.5 3.5 3.5 0 0 1-.58-3.23 3.4 3.4 0 0 1 .87-1.46l2.3-2.27a3.36 3.36 0 0 1 3.21-.86z" />
          <path d="M34.3 38.18c1-.83 2.45-.83 3.44 0 .28.21.52.47.72.75.2.21.4.87.63 1.22.47.1.96.12 1.44.09.42.03.83 0 1.24-.1.32-.5.52-1.07.57-1.66a5.36 5.36 0 0 0-.5-2.79 6.15 6.15 0 0 0-2.24-2.57 6.54 6.54 0 0 0-7.14 0 6.13 6.13 0 0 0-2.25 2.57c-.42.87-.6 1.84-.52 2.8.05.6.24 1.17.56 1.67.48.09.98.12 1.47.09.43.02.86-.02 1.28-.1.23-.36.42-1 .62-1.23.2-.28.43-.53.69-.74zm1.97 15.29c5 4.37 12.45 4.37 17.44 0a10.19 10.19 0 0 0 3.4-5.75c0-.11-.56-.46-1.26-.78-.38-.21-.8-.35-1.22-.4a20.25 20.25 0 0 1-3.82 3.09 11.33 11.33 0 0 1-11.64 0 20.46 20.46 0 0 1-3.84-3.1c-.47.08-.92.24-1.33.47-.61.29-1.06.58-1 .68.4 2.24 1.56 4.29 3.27 5.79zm13.39-13.24c.43.03.86 0 1.28-.09.23-.35.42-1 .62-1.22.2-.28.43-.53.7-.75 1-.83 2.44-.83 3.43 0 .27.21.52.47.72.75.2.21.4.87.63 1.22.48.09.96.12 1.44.09.41.02.83 0 1.24-.09.32-.5.51-1.08.57-1.67a5.36 5.36 0 0 0-.5-2.8 6.15 6.15 0 0 0-2.24-2.56 6.55 6.55 0 0 0-7.14 0 6.18 6.18 0 0 0-2.25 2.57c-.42.87-.6 1.84-.52 2.8.05.6.24 1.16.56 1.67.48.09.97.12 1.46.08z" />
        </g>
        <path
          d="M22.24 17.11a5.3 5.3 0 1 0-5.39 5.2m5.83-10.83a5.3 5.3 0 1 0-5.38 5.2m5.38 7.8a5.3 5.3 0 1 0-5.38 5.2"
          stroke={color}
          strokeWidth="2"
        />
      </g>
    </SVG>
  );
}
IconPlaybook.propTypes = {
  color: PropTypes.string,
};
IconPlaybook.defaultProps = {
  color: '#9F58F7',
};

export function IconTimeBank(props) {
  let { color, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 90 91">
      <g fill={color} fillRule="evenodd">
        <path d="M50 20.27c.57 0 1.07-.52 1.07-1.08 0-.57-.5-1.08-1.07-1.08a1.1 1.1 0 0 0-1.07 1.08c0 .56.5 1.08 1.07 1.08zm-1.93 6.51c0-.57-.5-1.08-1.07-1.08-.57 0-1.08.51-1.08 1.08 0 .56.51 1.08 1.08 1.08.56 0 1.07-.52 1.07-1.08zm-16.37-.74c-.56 0-1.07.5-1.07 1.08 0 .56.51 1.07 1.08 1.07.56 0 1.07-.5 1.07-1.07 0-.57-.5-1.08-1.07-1.08zm7.37 2.94c-.57 0-1.07.52-1.07 1.08v.01l1.07-.01 1.07.01v-.01c0-.56-.5-1.08-1.07-1.08zm.06-19.42c.56 0 1.07-.5 1.07-1.08 0-.56-.5-1.07-1.08-1.07-.56 0-1.07.5-1.07 1.07 0 .57.5 1.08 1.08 1.08zm7.53 2.94c.56 0 1.07-.5 1.07-1.07 0-.57-.5-1.08-1.07-1.08-.57 0-1.08.51-1.08 1.08 0 .57.51 1.08 1.08 1.08zM28.3 18.11c-.56 0-1.07.51-1.07 1.08 0 .56.52 1.08 1.08 1.08.57 0 1.08-.52 1.08-1.08 0-.57-.51-1.08-1.08-1.08zm16.32-.68H39.7l-5.89-6.45c-1.81-1.82-4.7.9-2.94 2.77l6.5 7.08c.35.45.86.68 1.48.68h5.78c2.49 0 2.77-4.08 0-4.08z" />
        <path d="M88.03 49.4H81.4c-.9-3.5-2.6-6.78-4.98-9.73l5.95-16.38c-9.5-2.86-15.73 2.85-17.67 7.02a46.91 46.91 0 0 0-8.73-3.44A18.4 18.4 0 1 0 23 28.08C9.67 33.06.54 43.28.54 55.1c0 8.6 4.84 16.35 12.62 21.86v13.57H27.8v-6.9a53.66 53.66 0 0 0 13.53 1.7 54 54 0 0 0 12.44-1.43v6.63H68.4V77.71a34.5 34.5 0 0 0 8.13-7.34h11.2c.9 0 2.17-.32 2.17-1.95V50.86c0-1.03-.68-1.46-1.86-1.46zM55.5 39.57a35.73 35.73 0 0 0-9.84-3.04 41.45 41.45 0 0 0-13.03-.03 36.1 36.1 0 0 0-9.08 2.65l-3.28-5.03a40 40 0 0 1 10.38-3.3 14.36 14.36 0 1 1 17 .03 43.77 43.77 0 0 1 4.8 1.18c2.21.68 4.32 1.52 6.3 2.53l-3.25 5.01z" />
      </g>
    </SVG>
  );
}
IconTimeBank.propTypes = {
  color: PropTypes.string,
};
IconTimeBank.defaultProps = {
  color: '#9F58F7',
};

export function IconHappyChat(props) {
  let { color, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 141 108">
      <path
        d="M114.26 15.02a27.12 27.12 0 0 0-19.91 7.67A27.6 27.6 0 0 0 86 42.48v24.06A3.42 3.42 0 0 0 89.35 70h23.87a27.21 27.21 0 0 0 23.86-13.28 27.7 27.7 0 0 0 .52-27.49 27.22 27.22 0 0 0-23.34-14.2zM105 31a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm8 22c-8.54 0-13.18-7.57-11.74-7.9 1.44-.32 3.91 1.75 11.74 1.75s10.33-2.15 11.75-1.81c1.41.33-3.2 7.96-11.75 7.96zm8-12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM85.16 85.7a77.05 77.05 0 0 0-20.69-7.87.3.3 0 0 1-.23-.3v-4.28c2.5-3.28 4.37-7 5.51-10.96 2.84-2.85 4.1-7.29 4.77-9.7 1.1-3.9 2.21-9.57-.84-13.61l-.13-.18c1.42-7.13 3.3-23.88-9.4-32.38v.01A7.88 7.88 0 0 0 66.4.73a.78.78 0 0 0-.27-.53.78.78 0 0 0-.56-.17c-.16 0-16.04 1.81-23.67.23-7.63-1.58-16.46 4.35-18.24 10.48A11.5 11.5 0 0 0 16.14 15c-3.46 4.28-4.53 11.12-3.15 20.29.08 1.18.25 2.34.44 3.54l-.14.17c-3.03 3.96-1.92 9.63-.8 13.53.67 2.4 1.92 6.87 4.76 9.68 1.13 4 3 7.74 5.52 11.04v4.28a.3.3 0 0 1-.23.3 76.64 76.64 0 0 0-20.7 7.86 3.67 3.67 0 0 0-.7 5.84A62.8 62.8 0 0 0 43.5 108a62.8 62.8 0 0 0 42.35-16.46 3.66 3.66 0 0 0-.69-5.84zM42.97 93A20.68 20.68 0 0 1 26 84.44 8.12 8.12 0 0 0 29.7 80a26.46 26.46 0 0 0 5.66 2.85 22.71 22.71 0 0 0 15.26 0A26.99 26.99 0 0 0 56.28 80 8.14 8.14 0 0 0 60 84.5 20.68 20.68 0 0 1 42.97 93zM62.8 58.1c-1.03 6.7-6.37 15.04-14.57 18a15.8 15.8 0 0 1-10.51 0c-8.48-3.02-13.51-11.46-14.53-18.04a.75.75 0 0 0-.68-.63c-.4 0-1.85-.64-3.63-6.92-1.42-4.92-.8-6.7-.33-7.32a1.6 1.6 0 0 1 1.41-.6h.25c.4.02.76-.29.79-.7 0-.1.87-10.7 7.15-14.5 3.13-1.92 7.16-1.85 11.96.2 9.9 4.24 17.16 3.93 21.6 2.94 5.1 3.74 3.62 9.75 3.29 10.9v.15c-.08.24-.03.5.12.71.15.2.4.31.66.28a1.8 1.8 0 0 1 1.69.58c.46.63 1.06 2.4-.33 7.32-1.78 6.3-3.23 6.9-3.63 6.93a.73.73 0 0 0-.7.7z"
        fill={color}
        fillRule="evenodd"
      />
    </SVG>
  );
}
IconHappyChat.propTypes = {
  color: PropTypes.string,
};
IconHappyChat.defaultProps = {
  color: '#9F58F7',
};

export function VideoOrbit(props) {
  let { color, playColor, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 147 106">
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.36 80.6a11.25 11.25 0 0 1-15.96-.82 11.25 11.25 0 0 1 .85-15.95 11.25 11.25 0 0 1 18.56 5.79c.2 0 .39.02.47.32 0 .2-.02.39-.32.47.6 3.6-.6 7.49-3.6 10.2zm34.97-46.67a8.54 8.54 0 0 0 .64-12.02 8.54 8.54 0 0 0-12.02-.62 8.54 8.54 0 0 0-.64 12.02 8.54 8.54 0 0 0 12.02.62zm34.6-17.47c.74.83 1.5 1.46 2.46 1.9l-.1.1-.11.1c-.1.09-.11.29.07.5l.1.1c.2 0 .4.02.6-.17l.1-.1a9.89 9.89 0 0 0 10.84-1.5 9.94 9.94 0 0 0 .75-14 9.94 9.94 0 0 0-13.99-.71 9.7 9.7 0 0 0-.72 13.78zm55.56 33.97a7.14 7.14 0 0 0-10.05-.52 7.52 7.52 0 0 0-2.36 5.3c-.09-.1-.18-.2-.38-.2l-.2-.02c-.2-.01-.4.18-.41.37.09.1-.02.2.08.3.1.1.18.21.29.12h.2c.2.02.3-.08.3-.28.12 1.59.63 3.2 1.75 4.44a7.14 7.14 0 0 0 10.05.52c2.9-2.62 3.34-7.14.73-10.03zm-29.35 24.55a5.6 5.6 0 0 0-7.88-.4 5.6 5.6 0 0 0-.42 7.87 5.6 5.6 0 0 0 7.88.4c2.37-1.95 2.47-5.6.42-7.87zm-43.1 14.06a10.3 10.3 0 0 0-5.18-3.03v-.2c.02-.19-.07-.3-.36-.4-.2-.02-.41.17-.51.26l-.01.2a9.48 9.48 0 0 0-7.93 2.45 9.94 9.94 0 0 0-.75 13.99 9.94 9.94 0 0 0 13.99.72 9.95 9.95 0 0 0 .74-13.99zm8.68-21.7a13.8 13.8 0 0 0 .94-19.4 11.28 11.28 0 0 0-3.71-2.84l-.09-.1s-.08-.1-.17 0a13.6 13.6 0 0 0-15.44 2.02 13.82 13.82 0 0 0-4.08 13.53c-.1.09-.18.17-.11.44l.08.09c.09.1.09.1.26.1.6 1.96 1.57 3.77 2.98 5.34a13.84 13.84 0 0 0 19.34.83zM60.85 43.06c-.18-.2-.38-.22-.6-.03-.2.19-.2.39-.02.6l.1.1c.18.2.38.21.58.03.21-.19.22-.39.04-.6l-.1-.1zm-4.84-5.58c-.09-.1-.38-.22-.59-.03-.2.18-.21.38-.03.59l.1.1c.18.21.38.22.59.04.2-.2.22-.4.03-.6l-.1-.1zM57.16 40c.19.2.39.22.6.03.2-.19.21-.39.03-.6l-.1-.1c-.18-.2-.38-.21-.59-.03-.2.19-.22.39-.03.6l.1.1zm1.59 1.76l.1.1c.18.21.38.22.59.03.2-.18.21-.38.03-.59l-.1-.1c-.1-.1-.38-.22-.59-.03-.2.18-.22.38-.03.59zm-4.22-6.14c-.18-.2-.38-.22-.59-.03-.2.18-.22.38-.03.59l.1.1c.18.21.38.22.59.03.2-.18.21-.38.03-.59l-.1-.1zm-11.7 28.91c0-.2-.29-.3-.48-.31l-.2-.01c-.2-.01-.31.28-.32.47l.1.1c.09.11.29.12.48.13l.2.01c.2 0 .3-.29.21-.39zm4.9-1.42c.02-.2-.27-.32-.47-.32l-.2-.01c-.2-.01-.31.28-.32.47l.1.11c.1.1.29.11.48.13h.2c.1.1.3-.08.22-.38zm-2.5.76c0-.2-.28-.31-.48-.32h-.2c-.2-.02-.31.27-.32.47l.1.1c.1.11.29.12.48.13l.2.01c.2 0 .4-.18.22-.39zm7.41-1.99c.01-.2-.28-.31-.47-.32h-.2c-.2-.02-.32.27-.32.47l.1.1c.09.11.28.12.48.13l.2.01c.2 0 .3-.29.21-.39zm2.5-.76c.02-.2-.27-.31-.47-.32l-.2.19c-.2-.01-.32.28-.32.48l.1.1c.09.1.28.11.48.13h.2c.1-.09.2-.38.22-.58zm-4.9 1.43c0-.2-.28-.31-.48-.32l-.2-.01c-.2-.01-.3.28-.32.47l.1.1c.1.11.29.12.49.13l.2.01c.18.01.2-.19.2-.38zm-9.82 2.65c0-.2-.28-.31-.48-.32l-.3.08c-.2 0-.31.28-.32.48l.1.1c.09.11.29.12.48.13l.2.01c.3-.09.31-.28.32-.48zm-12.23 3.32c.02-.2-.28-.32-.47-.32l-.2-.01c-.2-.01-.31.28-.32.47l.1.11c.09.1.29.11.48.12l.2.02c.1.1.2-.2.21-.4zm9.82-2.66c.01-.2-.28-.3-.47-.31l-.2-.02c-.2 0-.32.29-.32.48l.1.1c.09.11.28.12.48.13l.2.01s.2-.19.21-.39zM29.7 68.1l.1.1c.09.1.28.12.48.13l.2.01c.2.01.31-.28.32-.48 0-.2-.28-.3-.48-.32h-.2c-.4.17-.6.35-.42.56zm-5.01 1.32l.1.1c.09.11.29.12.48.13l.2.01c.2.01.31-.28.32-.47.01-.2-.28-.32-.48-.32l-.2-.01c-.3.07-.4.37-.42.56zm7.84-2.55l-.2-.01c-.2-.01-.31.28-.32.48l.1.1c.09.1.29.11.48.13h.2c.2.02.31-.27.32-.47a.96.96 0 0 0-.58-.23zm2.88-.35c.01-.2-.28-.3-.48-.31l-.2-.02c-.2 0-.3.29-.32.48l.1.1c.1.11.29.12.49.13l.2.01c.19 0 .4-.18.2-.39zm32.03 14.1c-.2-.02-.4.17-.5.26l-.02.2c0 .2 0 .2.08.3.1.1.1.1.3.11.2.01.4-.17.5-.27l.01-.2c.02-.2-.17-.4-.37-.4zm.8-2.04c.01-.2-.17-.4-.26-.5-.2-.02-.41.17-.42.36v.2c-.02.2-.02.2.07.3.1.11.1.11.3.12.2 0 .4-.18.4-.38l-.09-.1zm-.94 4.79c0-.2-.18-.4-.27-.5-.2-.02-.4.17-.5.26l-.02.2c0 .2 0 .2.08.3.1.1.1.1.3.11.2.01.4-.17.5-.26l-.1-.11zm1.37-7.24c0-.2-.18-.4-.27-.5-.2-.02-.4.17-.5.26l-.02.2c0 .2 0 .2.08.3.1.1.1.1.3.11.2.01.4-.17.5-.26l-.1-.1zm.42-2.44c.01-.2-.17-.4-.26-.5-.2-.02-.41.17-.51.26l-.01.2c-.01.2-.01.2.08.3.1.1.1.1.29.11.2.01.4-.17.5-.27l-.09-.1zm30.56-.9c.1.1.1.1 0 0l.3.11c.09.11.39.03.6-.16.1-.1.02-.4-.17-.6l-.1-.1c-.09-.11-.39-.02-.6.16-.11.3-.12.49-.03.6zm-2.18-1.59c-.1.1-.11.3.07.5l.1.1.09.11c.1.1.4.02.6-.16.1-.1.02-.4-.17-.6l-.09-.1c-.3-.13-.5-.14-.6.15zm-2.13-.9c.1.1.1.1 0 0l.3.11c.09.11.39.03.6-.16.1-.1.01-.4-.17-.6l-.1-.1c-.1-.11-.39-.02-.6.16-.22.38-.12.49-.03.6zm-6.52-3.7c.1.11.1.11 0 0l.3.12c.1.1.39.02.6-.17.1-.1.02-.39-.17-.6l-.1-.1c-.09-.1-.39-.02-.6.17-.21.38-.12.48-.03.59zm15.86 8.23l-.1-.1c-.09-.11-.39-.02-.6.16-.1.1-.1.3.08.5l.1.1.09.1c.1.11.4.03.6-.16.11-.29.03-.59-.17-.6zm-2.8-1.23c-.1.1-.11.3.07.5l.1.1.1.11c.09.1.38.02.6-.17.1-.09.01-.39-.17-.6l-.1-.1c-.29-.12-.59-.04-.6.16zm-10.24-6.15l-.1-.1c-.09-.11-.38-.03-.6.16-.1.1-.1.29.08.5l.1.1.1.1c.09.11.38.03.6-.16.1-.3.02-.6-.18-.6zm-4.3-2.5l-.1-.1c-.1-.11-.4-.03-.6.16-.1.1-.11.3.07.5l.1.1.1.1c.09.11.38.03.59-.16 0-.2-.07-.5-.17-.6zm5.82 3.76c-.1.1-.12.29.07.5l.1.1.09.1c.1.1.4.02.6-.16.1-.1.02-.4-.17-.6l-.1-.1c-.29-.12-.58-.04-.6.16zm36.04-12.95h.2c.2.02.4-.17.4-.36.02-.2-.17-.41-.36-.42h-.2c-.2-.02-.4.17-.42.37.1.1 0 .2.08.3 0 0 .1.1.3.1zm-25.3.47c.09.1.18.2.28.1l.2.02c.2.01.4-.18.42-.37 0-.2-.18-.4-.38-.42h-.2c-.2-.02-.4.17-.4.37-.01 0-.02.2.07.3zm22.97-1.19h-.2c-.2-.02-.41.17-.42.37.1.1 0 .2.08.3.1.1.19.2.3.1l.2.02c.2 0 .4-.18.4-.37a.43.43 0 0 0-.36-.42zm-37.9 1.5c.09.11.18.21.28.12h.2c.2.02.41-.17.42-.37 0-.2-.18-.4-.37-.4l-.2-.02c-.2 0-.41.18-.42.37-.1.1 0 .2.08.3zm7.51-.2c.1.1.19.2.3.11l.19.01c.2.01.4-.17.41-.37a.41.41 0 0 0-.37-.41l-.2-.01a.41.41 0 0 0-.41.37c-.1.1-.01.2.08.3zm-5.14.13c.1.1.19.2.3.11l.2.01c.2.01.4-.17.4-.37a.41.41 0 0 0-.37-.41l-.2-.01a.41.41 0 0 0-.41.37c.1.1.08.3.08.3zm7.52-.2c.1.1.18.2.29.1l.2.02c.2 0 .4-.18.41-.38.01-.2-.17-.4-.37-.4l-.2-.02c-.2 0-.4.18-.41.37-.02.2.08.3.08.3zm17.5-.39c.09.1.18.2.28.11l.2.01c.2.01.41-.17.42-.37 0-.2-.18-.4-.37-.41l-.2-.01c-.2-.01-.41.17-.42.37-.01.2.08.3.08.3zm-14.93.32c.09.1.18.2.29.11l.2.01c.2.01.4-.17.41-.37.01-.2-.18-.4-.37-.41l-.2-.01c-.2-.01-.4.17-.42.37 0 .2 0 .2.09.3zm4.94-.14c.1.1.19.2.3.11l.2.01c.2.01.4-.17.4-.37a.41.41 0 0 0-.37-.41l-.2-.01a.41.41 0 0 0-.41.37c-.01.2.08.3.08.3zm7.6-.1c.1.1.2.2.3.1l.2.02c.2 0 .4-.18.41-.37.01-.2-.17-.41-.37-.42h-.2c-.2-.02-.4.17-.41.37-.1.09-.01.2.08.3zm-2.56.06c.09.11.18.21.29.12h.2c.2.02.4-.17.41-.37.01-.2-.18-.4-.37-.4l-.2-.02c-.2 0-.4.18-.42.37 0 .2 0 .2.09.3zm12.99-1l-.2-.02c-.2 0-.41.18-.42.37.1.11 0 .2.08.3.1.11.19.21.3.12h.2c.2.02.4-.17.4-.36.02-.2-.17-.4-.36-.42zm-5.48.8c.1.1.19.2.3.11l.2.01c.2.01.4-.18.4-.37.02-.2-.17-.4-.36-.41l-.31.08c-.2-.01-.4.18-.41.37l.18.2zm-10.08.27c.1.1.18.2.29.11l.2.01c.2.01.4-.18.41-.37a.41.41 0 0 0-.37-.41l-.2-.01a.41.41 0 0 0-.41.37c.09.1-.02.2.08.3zm12.55-.24c.1.1.19.2.29.1l.2.02c.2 0 .4-.18.41-.38.01-.2-.17-.4-.37-.4l-.2-.02c-.2 0-.4.18-.41.37-.1.1-.01.2.08.3zm-27.48.56c.1.1.18.2.29.1l.2.02c.2 0 .4-.18.41-.37.01-.2-.17-.41-.37-.42h-.2c-.2-.02-.4.17-.41.37-.02.2-.02.2.08.3zm-9.06-24.66c-.2-.01-.39-.02-.6.17l-.1.1c-.1.09-.11.28.07.49l.1.1c.2.01.4.02.6-.16l.1-.1c.11-.29-.07-.5-.17-.6zm-1.2 2.21c-.2-.01-.39-.02-.6.17l-.1.09c-.1.1-.11.3.07.5l.1.1c.2.01.39.02.6-.16l.1-.1c.11-.3.12-.49-.17-.6zm-1.81 2.57c-.1.1-.11.3.07.5l.1.1c.2.01.39.02.6-.16l.1-.1c.01-.2.02-.39-.16-.6-.2 0-.4-.02-.6.17l-.11.1zm-2.22 4.43c-.1.1-.1.29.08.5l.1.1c.2 0 .38.02.6-.17l.1-.1c0-.2.02-.38-.17-.59-.2-.01-.4-.02-.6.17l-.1.09zm1.1-2.12c-.1.1-.1.3.08.5l.1.1c.2.01.39.02.6-.16l.1-.1c.01-.2.02-.39-.16-.6-.2 0-.4-.01-.6.17l-.11.1zm6.45-11.61c-.2-.01-.4-.02-.6.16l-.1.1c-.1.1-.12.29.07.5l.1.1c.2.01.39.02.6-.17l.1-.1c0-.19.02-.39-.17-.6zm3.5-6.54c-.2 0-.39-.02-.6.17l-.1.1c-.1.09-.1.28.08.49l.1.1c.2.02.38.03.59-.16l.1-.1c.12-.29.03-.58-.16-.6zm-2.3 4.33c-.2-.01-.39-.02-.6.17l-.1.1c-.1.09-.11.28.07.49l.1.1c.2.01.4.02.6-.16l.1-.1c0-.2.02-.4-.16-.6zm1.1-2.12c-.2 0-.39-.02-.6.17l-.1.1c-.1.09-.11.28.08.49l.09.1c.2.02.4.03.6-.16l.1-.1c.12-.29.03-.58-.16-.6zm-3.41 6.64c-.2-.01-.4-.02-.6.16l-.1.1c-.11.1-.12.29.07.5l.1.1c.2.01.39.02.6-.17l.1-.1c.11-.28-.08-.49-.17-.6z"
          fill={color}
        />
        <path
          d="M40.97 38.6v37.65h62.35V38.6H40.97zm3.12 3.14h56.11V73.1H44.1V41.74z"
          fill={color}
          fillRule="nonzero"
        />
        <g fill={playColor} fillRule="nonzero">
          <path d="M67.52 49.8c-.5.04-.92.55-.9 1.1v12.66c0 .74.87 1.3 1.47.92l10.04-6.33c.6-.38.6-1.5 0-1.87L68.1 49.95a.92.92 0 0 0-.57-.15z" />
        </g>
      </g>
    </SVG>
  );
}
VideoOrbit.propTypes = {
  color: PropTypes.string,
  playColor: PropTypes.string,
};
VideoOrbit.defaultProps = {
  color: '#9F58F7',
  playColor: '#FBFBFF',
};

export function Play(props) {
  let { className, color, ...otherProps } = props;
  return (
    <SVG
      className={cs(stylesheet.play, { [className]: className })}
      {...otherProps}
      viewBox="0 0 99 99"
    >
      <g fill="none">
        <path fill={color} d="m77.6,49.1l-42.32,21.16l0,-42.32l42.32,21.16z" />
        <circle
          stroke={color}
          strokeWidth="4.6"
          id="SVG_3"
          r="46.61"
          cy="49.39"
          cx="49.86"
        />
      </g>
    </SVG>
  );
}
Play.propTypes = {
  color: PropTypes.string,
};
Play.defaultProps = {
  color: 'white',
};

export function Agreement(props) {
  let { className, ...otherProps } = props;
  return (
    <SVG
      className={cs(stylesheet.agreement, { [className]: className })}
      {...otherProps}
      viewBox="0 0 107 110"
    >
      <path
        fill="currentColor"
        d="M72.736 29.357c0 1.793-1.403 3.205-3.184 3.205h-28.92c-1.78 0-3.184-1.412-3.184-3.205 0-1.793 1.403-3.205 3.184-3.205h28.915c1.657 0 3.189 1.412 3.189 3.205zm0 25.64c0-1.792-1.403-3.205-3.184-3.205H16.813c-1.78 0-3.184 1.413-3.184 3.205 0 1.793 1.403 3.205 3.184 3.205h52.605c1.786 0 3.319-1.412 3.319-3.205zm-3.184-16.025H16.813c-1.78 0-3.184 1.412-3.184 3.205 0 1.793 1.403 3.205 3.184 3.205h52.739c1.78 0 3.184-1.412 3.184-3.205 0-1.793-1.532-3.205-3.184-3.205zm-12.738 32.05c1.273-2.308 2.8-4.486 4.587-6.41H16.813c-1.781 0-3.185 1.413-3.185 3.206 0 1.792 1.404 3.205 3.185 3.205h40zm-40 12.82h36.303c.13-2.177.508-4.356 1.02-6.41H16.813c-1.781 0-3.184 1.413-3.184 3.206s1.527 3.205 3.184 3.205zm-.254 12.821h38.467c-.766-2.053-1.403-4.232-1.657-6.41H16.56c-1.781 0-3.185 1.412-3.185 3.205 0 1.793 1.404 3.205 3.185 3.205zM0 28.461v67.947C0 103.97 5.986 110 13.505 110l51.46-.005c-2.294-1.793-4.459-3.976-6.116-6.41H13.504c-3.95 0-7.135-3.205-7.135-7.181v-66.02h11.335c7.389 0 13.505-6.154 13.505-13.591V6.406h42.289c3.95 0 7.135 3.205 7.135 7.181v41.535c.89-.125 1.91-.125 2.93-.125 1.145 0 2.165 0 3.315.13l-.005-32.05v-9.485C86.873 6.03 80.887 0 73.368 0h-44.2c-.766 0-1.528.13-2.294.386-.766.255-1.403.77-1.91 1.282L1.78 24.098c-.637.51-1.02 1.282-1.403 2.053C.13 26.792 0 27.69 0 28.46zm107 57.305c0 13.075-10.444 23.587-23.435 23.587-12.997 0-23.441-10.637-23.441-23.587s10.444-23.587 23.435-23.587C96.556 62.18 107 72.691 107 85.766zm-9.554 9.23c-.253-.13-.636-.256-1.02-.386-3.945-.897-7.26-2.434-7.26-2.434-.382-.51-.636-1.537-.636-2.053.89-1.152 1.403-2.694 1.527-3.977.384.256 1.02.13 1.657-2.308.508-2.053.254-2.694-.253-2.82 1.527-7.692-2.04-7.947-2.04-7.947s-.508-1.027-2.04-1.923c-1.02-.641-2.295-1.027-4.076-.897-.507 0-1.144.13-1.657.256-.637.255-1.274.51-1.781.896-.637.386-1.274.897-1.781 1.538a7.614 7.614 0 0 0-2.04 3.59c-.384 1.282-.254 2.564.129 3.977-.637 0-1.403.385-.637 2.95.507 1.922 1.02 2.433 1.403 2.433.254 1.412.637 2.95 1.657 4.357-.13.51-.254 1.282-.637 1.923 0 0-3.438 1.668-7.389 2.694-.383.13-.766.256-1.02.386 2.93 4.487 8.026 7.437 13.882 7.437 5.986-.256 11.081-3.205 14.012-7.692z"
      />
    </SVG>
  );
}
Agreement.propTypes = {};
Agreement.defaultProps = {};

export function CrowdLove(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 59 57">
      <path
        d="M55.25 42.34a4.77 4.77 0 0 0 1.45-5.33 4.91 4.91 0 0 0-4.58-3.18c0-2.67-2.2-4.83-4.92-4.83a4.87 4.87 0 0 0-4.92 4.83v.1a5.18 5.18 0 0 0-1.96 0v-.1c0-2.67-2.2-4.83-4.92-4.83a4.87 4.87 0 0 0-4.92 4.83v.1a5.18 5.18 0 0 0-1.96 0v-.1c0-2.67-2.2-4.83-4.92-4.83a4.87 4.87 0 0 0-4.92 4.83v.1a5.18 5.18 0 0 0-1.96 0v-.1c0-2.67-2.2-4.83-4.92-4.83a4.87 4.87 0 0 0-4.92 4.83A4.91 4.91 0 0 0 2.3 37a4.77 4.77 0 0 0 1.45 5.33A7.13 7.13 0 0 0 0 48.66v7.37c0 .26.1.5.29.69a1 1 0 0 0 .7.28h57.03a1 1 0 0 0 .7-.28.96.96 0 0 0 .28-.69v-7.37a7.13 7.13 0 0 0-3.75-6.32zm-4.02-6.43a2.95 2.95 0 0 1 3.61 1.63c.46 1.09.2 2.33-.64 3.16a3 3 0 0 1-3.21.63 2.9 2.9 0 0 1-1.82-2.67 2.93 2.93 0 0 1 2.06-2.74zm-4.03-4.98c1.63 0 2.95 1.3 2.95 2.9v.43a4.87 4.87 0 0 0-2.5 2.46 2.73 2.73 0 0 1-2.15-.5 4.73 4.73 0 0 0-.92-1.09c-.21-.4-.33-.85-.33-1.3 0-1.6 1.32-2.9 2.95-2.9zm-8.48 6.35c.19-.33.44-.63.74-.86a2.91 2.91 0 0 1 4.4.86c.24.42.38.9.39 1.38 0 1.6-1.32 2.9-2.95 2.9a2.92 2.92 0 0 1-2.95-2.9c0-.48.13-.95.36-1.37h.01zm-3.32-6.35c1.63 0 2.95 1.3 2.95 2.9 0 .42-.1.84-.3 1.22-.15.14-.29.28-.42.44a4.73 4.73 0 0 0-.5.65 2.94 2.94 0 0 1-3.4 0 4.73 4.73 0 0 0-.9-1.09 2.65 2.65 0 0 1-.38-1.22c0-1.6 1.32-2.9 2.95-2.9zm-8.48 6.35c.19-.33.44-.63.74-.86a2.91 2.91 0 0 1 4.4.86c.24.42.38.9.39 1.38 0 1.6-1.32 2.9-2.95 2.9a2.92 2.92 0 0 1-2.95-2.9c0-.48.13-.95.36-1.37h.01zm-3.32-6.35c1.63 0 2.95 1.3 2.95 2.9 0 .42-.1.84-.3 1.22-.15.14-.29.28-.42.44a4.73 4.73 0 0 0-.5.65 2.94 2.94 0 0 1-3.4 0 4.73 4.73 0 0 0-.9-1.09 2.65 2.65 0 0 1-.38-1.22c0-1.6 1.32-2.9 2.95-2.9zm-8.48 6.35c.19-.33.44-.63.74-.86a2.91 2.91 0 0 1 4.4.86c.24.42.38.9.39 1.38 0 1.6-1.32 2.9-2.95 2.9a2.92 2.92 0 0 1-2.95-2.9c0-.48.13-.95.36-1.37h.01zm-3.32-6.35c1.63 0 2.95 1.3 2.95 2.9 0 .42-.1.84-.3 1.22-.15.14-.29.28-.42.44a4.73 4.73 0 0 0-.5.65c-.6.46-1.38.65-2.13.5a4.88 4.88 0 0 0-2.55-2.38 2.14 2.14 0 0 1 0-.43c0-1.6 1.32-2.9 2.95-2.9zm-4.92 4.83a3 3 0 0 1 2.95 2.9 2.9 2.9 0 0 1-1.82 2.67 3 3 0 0 1-3.21-.63 2.86 2.86 0 0 1-.64-3.15 2.95 2.95 0 0 1 2.72-1.8zm4.33 10.56c-.12.34-.2.68-.28 1.02v.18c-.06.37-.1.74-.1 1.12v6.43H1.98v-6.41a5.06 5.06 0 0 1 4.91-5.18 4.92 4.92 0 0 1 4.35 2.76l-.02.08zm1.08-2.04a6.93 6.93 0 0 0-2.28-1.93 4.8 4.8 0 0 0 1.79-3.7c.33 0 .66-.04.98-.11v.12a4.8 4.8 0 0 0 1.78 3.68 6.9 6.9 0 0 0-2.27 1.94zm10.33 10.79h-9.84v-6.41a5.42 5.42 0 0 1 .42-2.06 4.91 4.91 0 0 1 4.5-3.12c2.8.1 5 2.42 4.92 5.18v6.4zm-1.78-12.73a4.8 4.8 0 0 0 1.78-3.68v-.12a4.3 4.3 0 0 0 1.96 0v.12a4.8 4.8 0 0 0 1.78 3.68 6.95 6.95 0 0 0-2.76 2.68 6.95 6.95 0 0 0-2.76-2.68zm13.58 12.73h-9.84v-6.41a5.06 5.06 0 0 1 4.92-5.18c2.8.1 5 2.42 4.92 5.18v6.4zm-1.78-12.73a4.8 4.8 0 0 0 1.78-3.68v-.12a4.3 4.3 0 0 0 1.96 0v.12a4.8 4.8 0 0 0 1.78 3.68 6.95 6.95 0 0 0-2.76 2.68 6.95 6.95 0 0 0-2.76-2.68zm13.58 12.73h-9.84v-6.41a5.06 5.06 0 0 1 4.92-5.18 4.91 4.91 0 0 1 4.76 4.13c.08.34.14.7.16 1.05v6.4zm.49-10.79a6.9 6.9 0 0 0-2.27-1.93 4.8 4.8 0 0 0 1.78-3.7v-.11c.32.07.65.11.98.12a4.8 4.8 0 0 0 1.79 3.68 6.93 6.93 0 0 0-2.28 1.94zm10.32 10.79h-8.85v-6.41c0-.38-.03-.75-.1-1.12v-.18c-.06-.35-.15-.7-.27-1.04v-.08a4.92 4.92 0 0 1 4.3-2.76 5.05 5.05 0 0 1 4.92 5.18v6.4zM29.41 19.76c.33.32.86.32 1.2 0l8.07-7.68 1.4-1.36a6.08 6.08 0 0 0 0-8.82 6.85 6.85 0 0 0-9.41 0l-.66.63-.68-.65a6.85 6.85 0 0 0-9.42 0 6.08 6.08 0 0 0 0 8.81l9.5 9.07zM10 27c.22 0 .43-.1.6-.25l5.07-5.05A4.45 4.45 0 0 0 17 18.5a4.44 4.44 0 0 0-7-3.7 4.44 4.44 0 0 0-5.67.5A4.45 4.45 0 0 0 3 18.5c0 1.21.48 2.38 1.33 3.2l5.08 5.05c.16.16.37.25.59.25zm-5.25-8.5c0-.72.28-1.4.77-1.87a2.76 2.76 0 0 1 3.89 0c.33.33.85.33 1.18 0a2.75 2.75 0 0 1 3.89 0c.5.47.78 1.15.78 1.86 0 .71-.28 1.39-.78 1.86L10 24.8l-4.48-4.46a2.57 2.57 0 0 1-.77-1.85zM49 14.8a4.45 4.45 0 1 0-7 3.7c0 1.22.48 2.38 1.33 3.2l5.08 5.05c.33.33.85.33 1.18 0l5.08-5.05A4.45 4.45 0 0 0 56 18.5a4.45 4.45 0 0 0-7-3.7zm4.48 5.57L49 24.8l-4.48-4.46a2.56 2.56 0 0 1-.78-1.86c0-.7.28-1.38.78-1.86a2.76 2.76 0 0 1 3.89 0c.33.33.85.33 1.18 0a2.75 2.75 0 0 1 3.89 0c.5.48.78 1.15.78 1.86 0 .71-.28 1.39-.78 1.86v.03z"
        fill={color}
      />
    </SVG>
  );
}
CrowdLove.propTypes = {
  color: PropTypes.string,
};
CrowdLove.defaultProps = {
  color: 'currentColor',
};

export function Wave(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 1400 593">
      <path
        fill={color}
        fillRule="evenodd"
        d="m1400,192.14c-647.2,-248.73 -1113.87,-255.97 -1400,-21.7l0,342.56c700.54,-160.5 881.66,281.11 1400,-40.8l0,-280.06z"
      />
    </SVG>
  );
}
Wave.propTypes = {
  color: PropTypes.string,
};
Wave.defaultProps = {
  color: 'url(#white-to-gray)',
};

export function WaveUnder(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 1400 187">
      <path
        d="M1461 187H-61v-53.37C797.33-265.53 732.82 497.79 1461-43v230z"
        fill={color}
        fillRule="evenodd"
      />
    </SVG>
  );
}
WaveUnder.propTypes = {
  color: PropTypes.string,
};
WaveUnder.defaultProps = {
  color: undefined,
};

export function WaveTall(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 1400 920">
      <path
        d="M0 120.02c178.32 43.1 448.29 16.49 809.92-79.84C1060.99-26.7 1257.69-10.1 1400 90.02V920H0V120.02z"
        fill={color}
        fillRule="evenodd"
      />
    </SVG>
  );
}
WaveTall.propTypes = {
  color: PropTypes.string,
};
WaveTall.defaultProps = {
  color: '#FBFBFF',
};

export function WaveBottom(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 1400 131">
      <path
        fill={color}
        fillRule="evenodd"
        d="M1400 131H0V41.12C700.54-119.4 881.66 322.21 1400 .3V131z"
      />
    </SVG>
  );
}
WaveBottom.propTypes = {
  color: PropTypes.string,
};
WaveBottom.defaultProps = {
  color: '#ffffff',
};

export function WebsiteProfile(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 232 204">
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="40.98"
          cy="14.41"
          fill={color}
          fillRule="nonzero"
          rx="3.32"
          ry="3.33"
        />
        <ellipse
          cx="29.9"
          cy="14.41"
          fill={color}
          fillRule="nonzero"
          rx="3.32"
          ry="3.33"
        />
        <ellipse
          cx="18.83"
          cy="14.41"
          fill={color}
          fillRule="nonzero"
          rx="3.32"
          ry="3.33"
        />
        <path
          d="M221.91 204H10.1C4.54 204 0 200 0 195.13V8.87C0 3.99 4.54 0 10.09 0H221.9c5.56 0 10.1 4 10.1 8.87v186.26c0 4.88-4.54 8.87-10.09 8.87zM10.1 4.43c-2.78 0-5.05 2-5.05 4.44v186.26c0 2.44 2.27 4.44 5.05 4.44h211.8c2.78 0 5.05-2 5.05-4.44V8.87c0-2.44-2.27-4.44-5.05-4.44H10.1z"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="M225.8 151.9H5.04c-.76 0-1.27-.45-1.27-1.12 0-.66.5-1.1 1.27-1.1h220.74c.76 0 1.26.44 1.26 1.1 0 .67-.5 1.11-1.26 1.11zM2.52 22.17h227.05v4.43H2.52zm51.92 48.21A16.6 16.6 0 0 0 37.83 87a16.6 16.6 0 0 0 16.6 16.63A16.6 16.6 0 0 0 71.06 87c0-9.1-7.53-16.63-16.61-16.63zm0 24.83h-7.98s0-1.33.67-2.88c.44-1.11 2.66-1.55 5.32-2.66v-2.22s-.9-.66-.9-2c-.43 0-.66-1.33 0-1.77 0-.22-1.32-3.55.67-3.55.45-1.33 5.32-1.33 5.54.45.22 1.1-.66 2.88-.66 3.1.66.44.44 1.77 0 1.77 0 1.34-.89 2.22-.89 2.22v2c2.88 1.1 4.87 1.77 5.32 2.66.66 1.33.66 2.88.66 2.88h-7.75z"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="M87.42 66.95h98.3c1.06 0 1.45.1 1.84.32.4.2.7.51.9.9.22.4.33.78.33 1.85v37.08c0 1.07-.11 1.46-.32 1.85-.21.4-.52.7-.9.91-.4.21-.79.32-1.86.32h-98.3c-1.06 0-1.45-.11-1.84-.32-.4-.2-.7-.52-.9-.9-.22-.4-.33-.79-.33-1.86V92.77l-6.1-5.04 6.1-4.77V70.02c0-1.07.11-1.45.32-1.85.21-.39.52-.7.91-.9.4-.21.78-.32 1.85-.32z"
          stroke={color}
          strokeWidth=".8"
        />
        <path
          d="M153.82 83.68H94.6c-.84 0-1.4-.44-1.4-1.1 0-.67.56-1.12 1.4-1.12h59.22c.84 0 1.4.45 1.4 1.11 0 .67-.56 1.11-1.4 1.11zm-5.59 4.44H94.6c-.84 0-1.4-.45-1.4-1.11 0-.67.56-1.11 1.4-1.11h53.63c.84 0 1.4.44 1.4 1.1 0 .67-.56 1.12-1.4 1.12zm11.17-8.87H94.6c-.84 0-1.4-.45-1.4-1.11 0-.67.56-1.11 1.4-1.11h64.8c.84 0 1.4.44 1.4 1.1 0 .67-.56 1.12-1.4 1.12zm-42.45 17.74H94.6c-.84 0-1.4-.45-1.4-1.11 0-.67.56-1.11 1.4-1.11h22.35c.83 0 1.4.44 1.4 1.1 0 .67-.57 1.12-1.4 1.12zm-5.59 4.43H94.6c-.84 0-1.4-.44-1.4-1.1 0-.67.56-1.12 1.4-1.12h16.76c.84 0 1.4.45 1.4 1.11 0 .67-.56 1.11-1.4 1.11zm53.88 64.88h-138c-.75 0-1.25-.44-1.25-1.1 0-.67.5-1.11 1.26-1.11h138c.75 0 1.26.44 1.26 1.1 0 .67-.5 1.11-1.27 1.11zm0 8.87h-138c-.75 0-1.25-.44-1.25-1.1 0-.67.5-1.11 1.26-1.11h138c.75 0 1.26.44 1.26 1.1 0 .67-.5 1.11-1.27 1.11zm-63.07 8.87H27.75c-.76 0-1.26-.44-1.26-1.1 0-.67.5-1.11 1.26-1.11h74.42c.76 0 1.27.44 1.27 1.1 0 .67-.5 1.11-1.27 1.11z"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </SVG>
  );
}
WebsiteProfile.propTypes = {
  color: PropTypes.string,
};
WebsiteProfile.defaultProps = {
  color: '#BFC0D2',
};

export function WebsiteLayout(props) {
  let { color, ...otherProps } = props;
  return (
    <SVG {...otherProps} viewBox="0 0 290 255">
      <g fill={color}>
        <ellipse cx="58.35" cy="19.62" rx="5.3" ry="3.92" />
        <ellipse cx="44.21" cy="19.62" rx="5.3" ry="3.92" />
        <ellipse cx="26.52" cy="19.62" rx="5.3" ry="3.92" />
        <path d="M277.4 255H12.6C5.68 255 0 250.01 0 243.91V11.1C0 4.99 5.67 0 12.6 0h264.8c6.93 0 12.6 4.99 12.6 11.09V243.9c0 6.1-5.67 11.09-12.6 11.09zM12.6 5.54c-3.46 0-6.3 2.5-6.3 5.55V243.9c0 3.05 2.84 5.55 6.3 5.55h264.8c3.46 0 6.3-2.5 6.3-5.55V11.1c0-3.05-2.84-5.55-6.3-5.55H12.6z" />
        <path d="M3.54 27.46h282.93v3.92H3.54zm173.71 31.39h-71.58c-1.86 0-3.1-.79-3.1-1.97 0-1.17 1.24-1.96 3.1-1.96h71.58c1.87 0 3.12.79 3.12 1.96 0 1.18-1.25 1.97-3.12 1.97zm24.72 15.69H91.57c-1.9 0-3.16-.79-3.16-1.96 0-1.18 1.27-1.96 3.16-1.96h110.4c1.89 0 3.15.78 3.15 1.96 0 1.17-1.26 1.96-3.15 1.96zm-69.15 121.61H44.01c-.94 0-1.57-.78-1.57-1.96 0-1.17.63-1.96 1.57-1.96h88.81c.94 0 1.57.79 1.57 1.96 0 1.18-.63 1.96-1.57 1.96zm109.64 0h-88.82c-.94 0-1.57-.78-1.57-1.96 0-1.17.63-1.96 1.57-1.96h88.82c.94 0 1.56.79 1.56 1.96 0 1.18-.62 1.96-1.56 1.96zM132.82 168.7H44.01c-.94 0-1.57-.8-1.57-1.97 0-1.18.63-1.96 1.57-1.96h88.81c.94 0 1.57.78 1.57 1.96s-.63 1.96-1.57 1.96zm109.64 0h-88.82c-.94 0-1.57-.8-1.57-1.97 0-1.18.63-1.96 1.57-1.96h88.82c.94 0 1.56.78 1.56 1.96s-.62 1.96-1.56 1.96zm-109.64 43.15H44.01c-.94 0-1.57-.79-1.57-1.97 0-1.17.63-1.96 1.57-1.96h88.81c.94 0 1.57.79 1.57 1.96 0 1.18-.63 1.97-1.57 1.97zm109.64 0h-88.82c-.94 0-1.57-.79-1.57-1.97 0-1.17.63-1.96 1.57-1.96h88.82c.94 0 1.56.79 1.56 1.96 0 1.18-.62 1.97-1.56 1.97zm-109.64-27.47H44.01c-.94 0-1.57-.78-1.57-1.96 0-1.17.63-1.96 1.57-1.96h88.81c.94 0 1.57.79 1.57 1.96 0 1.18-.63 1.96-1.57 1.96zm109.64 0h-88.82c-.94 0-1.57-.78-1.57-1.96 0-1.17.63-1.96 1.57-1.96h88.82c.94 0 1.56.79 1.56 1.96 0 1.18-.62 1.96-1.56 1.96zm-109.64 43.16H44.01c-.94 0-1.57-.79-1.57-1.96 0-1.18.63-1.96 1.57-1.96h88.81c.94 0 1.57.78 1.57 1.96 0 1.17-.63 1.96-1.57 1.96zm84.88 0h-64.06c-.94 0-1.57-.79-1.57-1.96 0-1.18.63-1.96 1.57-1.96h64.06c.94 0 1.57.78 1.57 1.96 0 1.17-.63 1.96-1.57 1.96zM247.56 153H42.44V86.3h205.12V153zM45.6 150.22h198.82V89.1H45.59v61.13z" />
      </g>
    </SVG>
  );
}
WebsiteLayout.propTypes = {
  color: PropTypes.string,
};
WebsiteLayout.defaultProps = {
  color: '#BFC0D2',
};

export function WebsiteHappy(props) {
  let { color, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 124 100">
      <path
        d="M9.57 100H113.9a9.52 9.52 0 0 0 9.56-9.56V9.56A9.52 9.52 0 0 0 113.9 0H9.57A9.52 9.52 0 0 0 0 9.56v80.87A9.7 9.7 0 0 0 9.57 100zm104.46-6.64H9.57a2.95 2.95 0 0 1-2.92-2.92V30h110.17v60.42c0 1.73-1.2 2.93-2.79 2.93zM9.57 6.76H113.9a2.96 2.96 0 0 1 2.92 2.93v13.8L6.78 23.5V9.56c0-1.6 1.2-2.8 2.79-2.8zM82.8 72.79c-3.99 7.16-12.1 11.55-21 11.55s-16.88-4.39-21-11.42A3.27 3.27 0 0 1 42 68.4a3.27 3.27 0 0 1 4.51 1.2c2.92 5.04 8.77 8.1 15.15 8.1 6.5 0 12.49-3.19 15.28-8.23a3.27 3.27 0 0 1 4.52-1.2 3.2 3.2 0 0 1 1.34 4.52zM55.15 51.53l-14.75 8.9c-.53.26-1.06.52-1.73.52a3.13 3.13 0 0 1-2.8-1.59 3.35 3.35 0 0 1 1.07-4.51l9.3-5.58-9.16-4.12c-1.73-.8-2.4-2.65-1.73-4.38.66-1.73 2.66-2.4 4.39-1.73l15.01 6.64c1.2.53 1.86 1.6 2 2.8 0 1.19-.53 2.38-1.6 3.05zm31.5-6.51l-9.17 4.12 9.3 5.57c1.6.93 2.13 3.06 1.07 4.52a3.28 3.28 0 0 1-2.8 1.59c-.52 0-1.19-.14-1.72-.53l-14.89-8.76a3.27 3.27 0 0 1-1.59-3.06c.14-1.2.8-2.25 2-2.79l15.01-6.64c1.73-.8 3.6 0 4.4 1.73.78 1.73-.01 3.45-1.6 4.25zM24.45 15a4 4 0 0 1 3.99-3.99A4.08 4.08 0 0 1 32.43 15a4.08 4.08 0 0 1-4 3.98A4 4 0 0 1 24.45 15zm13.3 0a4 4 0 0 1 7.97 0 4.08 4.08 0 0 1-4 3.98c-2.11.13-3.98-1.73-3.98-3.98zm-26.59 0a4 4 0 0 1 3.99-3.99A4.08 4.08 0 0 1 19.14 15a4.08 4.08 0 0 1-4 3.98A4 4 0 0 1 11.16 15z"
        fill={color}
      />
    </SVG>
  );
}
WebsiteHappy.propTypes = {
  color: PropTypes.string,
};
WebsiteHappy.defaultProps = {
  color: '#9F58F7',
};

export class PlusPattern extends UniqueComponent {
  static propTypes = {
    className: PropTypes.string,
    viewBox: PropTypes.string,
    clippingPath: PropTypes.string,
    gradientStopColor1: PropTypes.string,
    gradientStopColor2: PropTypes.string,
    gradientX1: PropTypes.number,
    gradientY1: PropTypes.number,
    gradientX2: PropTypes.number,
    gradientY2: PropTypes.number,
    scale: PropTypes.number,
  };
  static defaultProps = {
    className: undefined,
    gradientStopColor1: '#ff6eff',
    gradientStopColor2: '#539bff',
    gradientX1: 0,
    gradientY1: 0,
    gradientX2: 1,
    gradientY2: 1,
    scale: 1,
  };

  constructor(props) {
    super(props);
    this.name = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '');
  }

  render() {
    return (
      <SVG viewBox={this.props.viewBox} className={this.props.className}>
        <defs>
          <path id={this.uniqueName('maskPath')} d={this.props.clippingPath} />

          <linearGradient
            id={this.uniqueName('linearGradientPattern')}
            gradientUnits="userSpaceOnUse"
            x1={`${this.props.gradientX1 * 100}%`}
            y1={`${this.props.gradientY1 * 100}%`}
            x2={`${this.props.gradientX2 * 100}%`}
            y2={`${this.props.gradientY2 * 100}%`}
          >
            <stop stopColor={this.props.gradientStopColor1} offset="0%" />
            <stop stopColor={this.props.gradientStopColor2} offset="100%" />
          </linearGradient>
          <rect
            id={this.uniqueName('gradientBox')}
            x="0"
            y="0"
            width="100%"
            height="100%"
            style={{ fill: this.uniqueUrl('linearGradientPattern') }}
          />

          <filter
            id={this.uniqueName('gradientFilter')}
            filterUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="100%"
            height="100%"
          >
            <feImage
              xlinkHref={this.uniqueId('gradientBox')}
              result="gradient"
            />
            <feImage xlinkHref={this.uniqueId('maskPath')} result="clip" />
            <feComposite
              in="gradient"
              in2="SourceAlpha"
              operator="in"
              result="grid-gradient"
            />
            <feComposite in="grid-gradient" in2="clip" operator="in" />
          </filter>

          <pattern
            id={this.uniqueName('crossPattern')}
            x="0"
            y="0"
            width="60"
            height="60"
            patternUnits="userSpaceOnUse"
          >
            <rect x="8" y="0" width="2" height="18" fill="red" />
            <rect x="0" y="8" width="18" height="2" fill="blue" />
          </pattern>

          <pattern
            id={this.uniqueName('scaledCrossPattern')}
            xlinkHref={this.uniqueId('crossPattern')}
            patternTransform={`scale(${this.props.scale})`}
          />
        </defs>

        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill={this.uniqueUrl('scaledCrossPattern')}
          filter={this.uniqueUrl('gradientFilter')}
        />
      </SVG>
    );
  }
}

export class GrillPattern extends UniqueComponent {
  static propTypes = {
    className: PropTypes.string,
    viewBox: PropTypes.string,
    clippingPath: PropTypes.string,
    gradientStopColor1: PropTypes.string,
    gradientStopColor2: PropTypes.string,
    gradientX1: PropTypes.number,
    gradientY1: PropTypes.number,
    gradientX2: PropTypes.number,
    gradientY2: PropTypes.number,
    scale: PropTypes.number,
    direction: PropTypes.oneOf(['left', 'right']),
  };
  static defaultProps = {
    className: undefined,
    gradientStopColor1: '#ff6eff',
    gradientStopColor2: '#539bff',
    gradientX1: 0,
    gradientY1: 0,
    gradientX2: 1,
    gradientY2: 1,
    scale: 1,
    direction: 'left',
  };

  render() {
    return (
      <SVG viewBox={this.props.viewBox} className={this.props.className}>
        <defs>
          <path id={this.uniqueName('maskPath')} d={this.props.clippingPath} />

          <linearGradient
            id={this.uniqueName('linearGradientPattern')}
            gradientUnits="userSpaceOnUse"
            x1={`${this.props.gradientX1 * 100}%`}
            y1={`${this.props.gradientY1 * 100}%`}
            x2={`${this.props.gradientX2 * 100}%`}
            y2={`${this.props.gradientY2 * 100}%`}
          >
            <stop stopColor={this.props.gradientStopColor1} offset="0%" />
            <stop stopColor={this.props.gradientStopColor2} offset="100%" />
          </linearGradient>
          <rect
            id={this.uniqueName('gradientBox')}
            x="0"
            y="0"
            width="100%"
            height="100%"
            style={{
              fill: this.uniqueUrl('linearGradientPattern'),
            }}
          />

          <filter
            id={this.uniqueName('gradientFilter')}
            filterUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="100%"
            height="100%"
          >
            <feImage
              xlinkHref={this.uniqueId('gradientBox')}
              result="gradient"
            />
            <feImage xlinkHref={this.uniqueId('maskPath')} result="clip" />
            <feComposite
              in="gradient"
              in2="SourceAlpha"
              operator="in"
              result="grid-gradient"
            />
            <feComposite in="grid-gradient" in2="clip" operator="in" />
          </filter>

          <pattern
            id={this.uniqueName('grillPattern')}
            x="0"
            y="0"
            width="22"
            height="22"
            patternUnits="userSpaceOnUse"
          >
            <line
              strokeLinecap="square"
              x1="11"
              y1="0"
              x2={this.props.direction === 'left' ? '22' : '0'}
              y2="11"
              stroke="red"
              strokeWidth="2"
            />
            <line
              strokeLinecap="square"
              x1={this.props.direction === 'left' ? '0' : '22'}
              y1="11"
              x2="11"
              y2="22"
              stroke="blue"
              strokeWidth="2"
            />
          </pattern>

          <pattern
            id={this.uniqueName('scaledGrillPattern')}
            xlinkHref={this.uniqueId('grillPattern')}
            patternTransform={`scale(${this.props.scale})`}
          />
        </defs>

        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill={this.uniqueUrl('scaledGrillPattern')}
          filter={this.uniqueUrl('gradientFilter')}
        />
      </SVG>
    );
  }
}

export class ClippedImage extends UniqueComponent {
  static propTypes = {
    src: PropTypes.string,
    xAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    yAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    fillMode: PropTypes.oneOf(['meet', 'slice']),
    viewBox: PropTypes.string,
    clippingPath: PropTypes.string,
    overlayColor: PropTypes.string,
  };
  static defaultProps = {
    xAlignment: 'Mid',
    yAlignment: 'Mid',
    fillMode: 'slice',
    overlayColor: 'transparent',
  };

  render() {
    let {
      src,
      xAlignment,
      yAlignment,
      fillMode,
      viewBox,
      clippingPath,
      overlayColor,
      ...otherProps
    } = this.props;

    return (
      <SVG
        {...otherProps}
        viewBox={viewBox}
        preserveAspectRatio={`x${xAlignment}Y${yAlignment} ${fillMode}`}
      >
        <defs>
          <pattern
            id={this.uniqueName('ImagePattern')}
            patternUnits="userSpaceOnUse"
            width="100%"
            height="100%"
          >
            <image
              xlinkHref={src}
              x="0"
              y="0"
              width="100%"
              height="100%"
              preserveAspectRatio={`x${xAlignment}Y${yAlignment} ${fillMode}`}
            />
            <rect
              width="100%"
              height="100%"
              transform="translate(0,0)"
              fill={overlayColor}
            />
          </pattern>
        </defs>

        <path fill={this.uniqueUrl('ImagePattern')} d={clippingPath} />
      </SVG>
    );
  }
}

export class IPhoneX extends UniqueComponent {
  static propTypes = {
    src: PropTypes.string,
    xAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    yAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    fillMode: PropTypes.oneOf(['meet', 'slice']),
  };
  static defaultProps = {
    xAlignment: 'Mid',
    yAlignment: 'Mid',
    fillMode: 'slice',
  };

  render() {
    let {
      src,
      xAlignment,
      yAlignment,
      fillMode,
      className,
      ...otherProps
    } = this.props;

    return (
      <div
        className={cs(stylesheet.iPhoneXContainer, { [className]: className })}
      >
        <div className={stylesheet.iPhoneWidthMod}>
          <SVG
            className={stylesheet.iPhoneXBody}
            {...otherProps}
            viewBox="0 0 252 505"
          >
            <defs>
              <linearGradient
                id={this.uniqueName('horizontal-gradient')}
                x1="100%"
                x2="0%"
                y1="50%"
                y2="50%"
              >
                <stop offset="0%" stopColor="#ffffff" stopOpacity=".6" />
                <stop offset="100%" stopColor="7D8A9F" stopOpacity=".4" />
              </linearGradient>
              <linearGradient
                id={this.uniqueName('vertical-gradient')}
                x1="50%"
                x2="50%"
                y1="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#ffffff" stopOpacity=".6" />
                <stop offset="100%" stopColor="#7D8A9F" stopOpacity=".4" />
              </linearGradient>
              <linearGradient
                id={this.uniqueName('ear-gradient')}
                x1="50%"
                x2="50%"
                y1="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#7D8A9F" stopOpacity=".1" />
                <stop offset="115%" stopColor="#ffffff" stopOpacity=".6" />
              </linearGradient>
            </defs>

            <g fill="none" fillRule="evenodd" transform="translate(.95 .9)">
              <path
                d="M249.65 174.3v293.25A36.45 36.45 0 0 1 213.2 504H37.8a36.45 36.45 0 0 1-36.45-36.45V186.02H0v-36.04h1.35v-9.9H0v-36.04h1.35V86.93H0V68.46h1.35V36.45A36.45 36.45 0 0 1 37.8 0h175.4a36.45 36.45 0 0 1 36.45 36.45v80.2H251v57.66h-1.35z"
                fill="#FFF"
              />
              <rect
                height="503.5"
                width="247.8"
                opacity=".25"
                rx="36.45"
                stroke={this.uniqueUrl('horizontal-gradient')}
                strokeWidth=".5"
                x="1.6"
                y=".25"
              />
              <rect
                height="494.49"
                width="238.8"
                opacity=".25"
                rx="31.95"
                stroke={this.uniqueUrl('vertical-gradient')}
                strokeWidth=".5"
                x="6.1"
                y="5.2"
              />
              <rect
                height="4.05"
                width="30.14"
                fill={this.uniqueUrl('ear-gradient')}
                rx="2.03"
                x="110.21"
                y="17.57"
              />
            </g>
          </SVG>

          <ClippedImage
            className={stylesheet.iPhoneXScreen}
            src={src}
            xAlignment={xAlignment}
            yAlignment={yAlignment}
            fillMode={fillMode}
            viewBox="0 0 217 473"
            clippingPath={
              'M47.23 0v5.86c0 6.21 5.04 11.26 11.25 11.26h98.96c6.2 0 11.24-5.05 11.24-11.26V0h25.64a22.96 22.96 0 0 1 22.94 22.97v426.98a22.96 22.96 0 0 1-22.94 22.97H22.94A22.96 22.96 0 0 1 0 449.95V22.97A22.96 22.96 0 0 1 22.94 0h24.3zM71.3 463.01a2.03 2.03 0 1 0 0 4.06h74.21a2.03 2.03 0 1 0 0-4.06H71.3z'
            }
          />
        </div>
      </div>
    );
  }
}

export function LogoPCO(props) {
  return (
    <SVG {...props} viewBox="0 0 124 21">
      <defs>
        <linearGradient id="LogoPCO_Gradient_Colors">
          <stop offset="0%" stopColor="#1D6EE1" />
          <stop offset="55%" stopColor="#1D5AE1" />
          <stop offset="100%" stopColor="#4855FF" />
        </linearGradient>

        <linearGradient
          id="LogoPCO_Gradient_A"
          href="#LogoPCO_Gradient_Colors"
          x1="50%"
          x2="50%"
          y1="-190.66%"
          y2="326%"
          gradientUnits="objectBoundingBox"
        />

        <linearGradient
          id="LogoPCO_Gradient_B"
          href="#LogoPCO_Gradient_Colors"
          x1="50%"
          x2="50%"
          y1="0%"
          y2="106%"
          gradientUnits="objectBoundingBox"
        />
      </defs>
      <g fill="none">
        <path
          d="M86.21 14.14a3.79 3.79 0 0 1-3.82-3.74 3.86 3.86 0 0 1 3.84-3.8 3.26 3.26 0 0 1 2.66 1.27c.06.08.1.19.08.29a.4.4 0 0 1-.16.25l-.6.53a.34.34 0 0 1-.22.1.45.45 0 0 1-.28-.14c-.37-.42-.9-.68-1.46-.7a2.08 2.08 0 0 0-2.07 2.15 2.1 2.1 0 0 0 2.05 2.17c.6.01 1.16-.24 1.55-.7l.11-.1a.4.4 0 0 1 .29-.13c.09 0 .18.03.25.09l.49.4c.21.16.26.35.13.53a3.25 3.25 0 0 1-2.84 1.53zm6.93 0a3.62 3.62 0 0 1-3.68-3.75 3.65 3.65 0 0 1 3.66-3.75 3.25 3.25 0 0 1 3.34 3.79.36.36 0 0 1-.36.33h-4.85a1.97 1.97 0 0 0 2 1.84c.57-.02 1.12-.2 1.6-.51.1-.07.2-.12.33-.14.08 0 .16.05.2.12l.51.68a.3.3 0 0 1-.04.5 4.3 4.3 0 0 1-2.71.89zm-.04-6.08a1.76 1.76 0 0 0-1.8 1.46l3.38.05a1.6 1.6 0 0 0-1.58-1.51zm10.11 5.9a.37.37 0 0 1-.38-.36V9.96c0-1.11-.52-1.73-1.47-1.73-.79 0-1.52.39-1.98 1.03v4.34c0 .26-.13.36-.44.36h-.95a.38.38 0 0 1-.38-.36V7.18a.4.4 0 0 1 .38-.37h.53c.15 0 .28.1.32.23l.18.5a4.5 4.5 0 0 1 2.55-.91c1.94 0 3.06 1.26 3.06 3.4v3.56a.38.38 0 0 1-.38.37h-1.04zm4.8.18c-1.68 0-1.88-1.22-1.88-2.14V8.4l-.74-.05a.37.37 0 0 1-.37-.37v-.8a.37.37 0 0 1 .37-.37h.68l.05-2.2c0-.2.17-.37.38-.37h1.03c.2 0 .36.17.36.37v2.16l1.82.04a.36.36 0 0 1 .38.37v.77a.37.37 0 0 1-.38.37h-1.75l-.04 3.47c0 .64.27.69.55.69.38-.04.75-.14 1.1-.32a.46.46 0 0 1 .18-.04h.08c.1.04.16.1.2.2l.32.78a.32.32 0 0 1-.18.46 5.6 5.6 0 0 1-2.16.58zm6.25 0a3.62 3.62 0 0 1-3.68-3.75 3.65 3.65 0 0 1 6.07-2.82 3.28 3.28 0 0 1 .94 2.85.36.36 0 0 1-.36.33h-4.86a1.97 1.97 0 0 0 2 1.84c.57-.02 1.12-.2 1.6-.51.1-.07.21-.12.33-.13.08 0 .16.04.2.12l.52.67a.3.3 0 0 1-.05.5 4.3 4.3 0 0 1-2.71.9zm0-6.08a1.76 1.76 0 0 0-1.8 1.46l3.38.05a1.6 1.6 0 0 0-1.58-1.51zm4.58 5.9a.38.38 0 0 1-.38-.36V7.18a.4.4 0 0 1 .38-.37h.53c.16.01.3.12.34.27l.15.46a3.13 3.13 0 0 1 2.14-.9c.5 0 1.14.09 1.33.37a.3.3 0 0 1 0 .32l-.43.87a.33.33 0 0 1-.31.21.44.44 0 0 1-.17-.04 1.89 1.89 0 0 0-2.22.71v4.52c0 .34-.25.36-.53.36h-.83zm-84.18 0c-.64.01-1.16-.5-1.17-1.15V4.06c0-.2.17-.36.37-.37h1.04c.2 0 .37.16.37.37v7.8a.36.36 0 0 0 .37.35h.14a.24.24 0 0 1 .25.23v1.26a.24.24 0 0 1-.25.24l-1.12.02zm4.44.18a2.25 2.25 0 0 1-2.38-2.4c0-1.38 1.18-2.31 2.94-2.31.45 0 .9.06 1.34.18.06-.67 0-1.02-.24-1.23-.22-.19-.5-.27-.79-.25-.68.02-1.36.12-2.02.32h-.1c-.16 0-.28-.12-.34-.32l-.15-.63a.35.35 0 0 1 .26-.44 7.57 7.57 0 0 1 2.52-.41c2.38 0 2.58 1.44 2.58 3.16v3.8a.38.38 0 0 1-.38.36h-.51c-.2 0-.27-.1-.34-.27l-.14-.37c-.64.52-1.43.8-2.25.81zm.7-3.57c-.87 0-1.43.45-1.43 1.14a1.05 1.05 0 0 0 1.07 1.1 2.13 2.13 0 0 0 1.6-.85v-1.08c-.38-.21-.8-.31-1.24-.3zm9.61 3.39a.37.37 0 0 1-.37-.36V9.96c0-1.11-.53-1.73-1.48-1.73-.78 0-1.52.39-1.97 1.03v4.34c0 .26-.14.36-.45.36h-.95a.38.38 0 0 1-.38-.36V7.18c0-.2.18-.37.38-.37h.53c.15 0 .28.1.32.23l.18.5a4.4 4.4 0 0 1 2.55-.9c1.94 0 3.05 1.26 3.05 3.39v3.57a.38.38 0 0 1-.37.36H49.4zm8.33 0a.37.37 0 0 1-.37-.36V9.96c0-1.11-.53-1.73-1.48-1.73-.78 0-1.52.39-1.97 1.03v4.34c0 .26-.14.36-.45.36h-.95a.38.38 0 0 1-.37-.36V7.18c0-.2.17-.37.37-.37h.53c.15 0 .28.1.32.23l.18.5a4.49 4.49 0 0 1 2.54-.9c1.94 0 3.06 1.26 3.06 3.39v3.57c0 .2-.18.36-.38.36h-1.03zm3.69-8.31a1.07 1.07 0 0 1 0-2.14 1.07 1.07 0 0 1 0 2.14zm-.49 8.31a.38.38 0 0 1-.38-.36V7.18c0-.2.17-.37.38-.37h1.03c.2 0 .37.16.38.37v6.42a.38.38 0 0 1-.38.36h-1.03zm8.46 0a.37.37 0 0 1-.37-.36V9.96c0-1.11-.52-1.73-1.47-1.73-.79 0-1.53.39-1.98 1.03v4.34c0 .25-.14.36-.45.36h-.94a.38.38 0 0 1-.38-.36V7.18a.4.4 0 0 1 .38-.37h.53c.15 0 .28.1.32.23l.18.5a4.49 4.49 0 0 1 2.55-.9c1.14 0 3.06.44 3.06 3.39v3.57a.38.38 0 0 1-.38.36H69.4zm5.9 4.11a5.4 5.4 0 0 1-2.85-.92.27.27 0 0 1-.09-.36l.4-.76a.28.28 0 0 1 .38-.1c.54.33 1.15.51 1.77.54a2.6 2.6 0 0 0 2.02-.72c.36-.36.55-.85.5-1.36v-.14a5 5 0 0 1-1.97.47c-2.11 0-3.7-1.73-3.7-4.02 0-2.29 1.56-4.05 3.62-4.05.88-.02 1.73.31 2.36.92l.18-.53a.29.29 0 0 1 .28-.21h.72c.18 0 .32.14.33.32v7.5c0 1.94-1.59 3.34-3.85 3.4l-.1.02zm.3-9.84c-1.26 0-2.11 1-2.11 2.47 0 1.47.9 2.45 2.19 2.45.47 0 .93-.11 1.35-.32a.8.8 0 0 0 .46-.73V9.57a.78.78 0 0 0-.14-.44 2.12 2.12 0 0 0-1.75-.9zm-50.1 9.45a.38.38 0 0 1-.39-.36V6.75a.33.33 0 0 1 .33-.31h.68a.3.3 0 0 1 .28.2l.1.63.06-.06a3.44 3.44 0 0 1 2.4-.94c2.07 0 3.63 1.75 3.63 4.06 0 2.3-1.59 4.01-3.7 4.01-.66 0-1.3-.18-1.89-.5l-.07 3.5a.37.37 0 0 1-.41.37l-1.03-.03zm3.26-9.84c-.7 0-1.35.34-1.75.92a.79.79 0 0 0-.13.44v2.53c0 .31.18.6.46.73.42.2.88.31 1.35.31 1.26 0 2.19-1 2.19-2.44 0-1.45-.86-2.5-2.13-2.5h.01z"
          fill="#313239"
        />
        <path
          d="M12.64 7.88l-2.2.7c-.48.16-.99.16-1.46 0l-2.23-.65a.19.19 0 0 0-.17.03.2.2 0 0 0-.07.15v2.74c0 .08.05.15.13.18l2.74.82c.21.06.44.06.66 0l2.74-.89a.2.2 0 0 0 .13-.18V8.06a.19.19 0 0 0-.09-.16.19.19 0 0 0-.18-.02z"
          fill="#1D5AE1"
          transform="translate(1 .92)"
        />
        <path
          d="M17.18 2L11.25.23c-1.02-.3-2.1-.3-3.12 0L2.23 2A3.2 3.2 0 0 0 0 5.06v9.68c0 1.4.9 2.64 2.23 3.06l5.9 1.8c1.02.3 2.1.3 3.12 0l5.9-1.77a3.22 3.22 0 0 0 2.23-3.08v-9.7A3.2 3.2 0 0 0 17.18 2zm-2.32 9.38c0 .63-.4 1.18-1 1.36l-3.44 1.05c-.46.14-.96.14-1.42 0l-2.32-.7a.13.13 0 0 0-.11.02.13.13 0 0 0-.06.1v1.59a.5.5 0 0 1-.2.4.49.49 0 0 1-.42.08l-.98-.3a.5.5 0 0 1-.35-.47V7.12c0-.44.2-.86.56-1.13.35-.26.8-.35 1.22-.22l3.04.9c.2.06.42.06.62 0l3.04-.98a1.4 1.4 0 0 1 1.82 1.35v4.34z"
          fill="#1D5AE1"
          transform="translate(1 .92)"
        />
      </g>
    </SVG>
  );
}

export function LogoChimp(props) {
  return (
    <SVG {...props} viewBox="0 0 134 139">
      <g fill="none">
        <path
          d="M131.91 99.33c-.11.35-10.43 39.68-51 39.67-35.06-.01-51.68-30.22-51.68-30.22-2.55.14-5.02-.26-7.3-1.09-10.28-3.74-15.21-15.4-11.67-25.2l-5.65-4.28c-21.9-16.53 40.14-92.2 62.08-75.08l5.24 4.17C79.8 2.56 87.6 0 93.95 0c4.5 0 8.27 1.3 10.8 4.01 5.7 6.12 3.65 17.78-4.12 29.6a19.39 19.39 0 0 1 4.04 5.84c2.48 1.89 4.08 4.76 4.87 8.73.9 4.41 1.08 10.7 1.63 13.4 2.1.94 1.2.5 3.44 1.61a30.54 30.54 0 0 1 8.3 5.55c5.58 1.39 7.71 7.27 4.45 11.28l-.89 1.03c.1.25 1.17 1.97 1.94 5.46a7.36 7.36 0 0 1 5.12 4c1.67 4-1.62 8.82-1.62 8.82zm-16.08 29.7v1.65h.64v-1.65h.65v-.52h-1.93v.52h.64zm1.48-.52v2.17h.58v-1.57l.48 1.57h.5l.46-1.57v1.57h.58v-2.17h-.9l-.4 1.25-.4-1.25h-.9z"
          fill="#684C46"
        />
        <path
          d="M37.82 84.59c.89-2.23 1.33-4.07 1.33-4.07a25.5 25.5 0 0 1 1.33 9.58c.84-1.11 1.75-3.2 1.75-3.2 1.56 9.13-5.16 17.49-14 17.49-7.86 0-14.23-6.65-14.23-14.86 0-8.2 6.37-14.85 14.22-14.85 2.04 0 3.98.45 5.73 1.25 0 0 3.02 1.52 3.87 8.66zm77.4 32.19c11.03-8.6 12.96-18.94 13.14-19.3 2.71-3.23 1.98-6.4-1.6-6.4-1.15 0-2 .29-2 .29s0-4.71-2.2-8.38c-1.69 1.89-6.39 5.63-12.55 8.54a58.36 58.36 0 0 1-23.07 5.42c-2.68.12-4.33-.32-5.27 2.78-.3 1.1-.16 2.72.06 3.19.75 2.56 2.73 3.7 5.32 4.3 1.97.45 4.06.49 4.06.49 19.4.54 34.97-14.46 35.15-14.59.18-.15.33-.32.33-.32l-.19.44c-2.8 6.25-19.02 17.58-35.17 17.26l-.05.02c-3.74-.02-8.3-.97-10.66-3.88-3.74-4.6-1.8-12.26 4.17-12.44l1.99-.04c14.76-.45 28.01-5.83 37.5-17.07 1.3-1.6-.15-3.81-2.98-3.88a.1.1 0 0 1-.07-.03c-3.35-3.56-6.3-4.82-8.92-6.14-5.5-2.78-4.98-.38-6.25-13.85-.35-3.63-1.04-8.58-4.26-10.48a5.26 5.26 0 0 0-2.72-.71c-.95 0-1.4.2-1.6.23-1.75.39-2.76 1.38-4.01 2.53-5.93 5.42-10.67 3.95-17.74 3.89a13.55 13.55 0 0 0-13.64 11.6c-.54 3.7-.2 7.45.4 9.14 0 0-1.81-1.2-2.67-2.25 1.04 6.45 6.97 10.67 6.97 10.67-.93.21-2.28.12-2.28.12.01 0 3.39 2.66 6.32 3.58-.76.48-4.63 4.26-6.62 9.47-1.87 4.88-1.1 10.73-1.1 10.73l1.61-2.4s-1.06 5.34 1 10.52c.67-1.54 2.16-4.29 2.16-4.29s-.24 5.74 2.55 10.43c.07-1.08.49-3.84.49-3.84s1.6 4.9 5.28 8.32c6.91 6.08 25.2 7.18 39.13-3.67z"
          fill="#F5DCBA"
        />
        <path
          d="M12.4 78c-.06-.01-5.33-3.87-6.08-5.14-4.43-7.47 3.28-22.8 8.77-31.52C28.65 19.8 51.22 2.8 61.47 5.24L72 10.65a85.18 85.18 0 0 0-10.41 7.3l-2.24 1.88s-6.54 4.4-9.8 7.17C36.51 38.1 23.67 55.3 18.9 71.9c0 0-3.9 1.94-6.5 6.09z"
          fill="#0788BF"
        />
        <path
          d="M61 5.23C50.84 2.8 28.46 19.85 15.01 41.46l-.01.02h.05L25.77 50C37.53 31.14 52.3 21.42 52.73 21.14l-1.7-11.55 3.19-1.53 6.38 2.08L60.11 8 61 5.23z"
          fill="#46B8E3"
        />
        <path
          d="M72 11.33l-10.62 7.12-.74.55-9.42-7.33-.22-1.39 3.27-1.49 6.58 2.03.1-3.89.3-.88L64.14 5 72 11.33z"
          fill="#FFD14F"
        />
        <path
          d="M93.14 5.2c-6.93 0-14.7 3.58-20.66 7.1-.84.49-1.67 1-2.48 1.5l-3.12-2.56L68 15.1l-1.26.86-6.44-1.93 4.26 3.5c-.97.73-1.84 1.41-2.56 2l-10.23-8.3.54 3.72 7.43 6.44s-6.58 4.35-9.85 7.1c-13.12 11-26.03 28.03-30.82 44.47l.27-.15.1-.06.4-.2.26-.13.42-.18.24-.1.44-.18.21-.08.65-.2a18.6 18.6 0 0 1 12.87.6c2.6-6.47 5.72-13.03 10.62-19.35 3.98-5.11 7.8-9.68 12.39-12.2 8.68-8.02 32.1-16.52 39.6-9.15a48.62 48.62 0 0 0 4.57-8.93c3.13-8.14 3.19-17.46-8.98-17.46zm-29.72 7.2l-1.53-5.47-.9 2.72.54 2.14 1.89.6z"
          fill="#122030"
        />
        <path
          d="M124.99 92.6s0-4.73-2.2-8.4c-1.69 1.89-6.4 5.64-12.58 8.55a58.41 58.41 0 0 1-23.1 5.44c-2.69.12-4.35-.31-5.28 2.8-.07.26-.12.56-.15.87v.03a7.49 7.49 0 0 0-.01 1.05v.06c0 .14.02.27.03.4v.03c.07.5.17.72.18.75l.02.04c.76 2.54 2.73 3.67 5.31 4.27 1.98.45 4.07.5 4.07.5 15.85.44 29.16-9.5 33.62-13.24.08-1.05.12-1.8.09-3.15zM79.44 8.5c3.79-1.73 7.85-3.1 11.74-3.5-3.87.86-8.58 2.85-14.16 6.25-.14.08-13.21 8.84-21.2 16.7-4.35 4.3-21.83 25.1-21.82 25.09 3.2-6 5.3-8.95 10.36-15.27a141.84 141.84 0 0 1 12.2-13.39c.4-.38 9.54-9.67 22.88-15.88z"
          fill="#FFF"
        />
        <path
          d="M114.88 116.27a38.59 38.59 0 0 1-5.87 3.73c-4.65-1.73-7.5-5.43-7.5-5.43s3.98-.93 9.32-3.59A50.78 50.78 0 0 0 128 97.2c-.18.36-2.1 10.58-13.12 19.07zm-12.66-49.28c-2.25-1.57-5.97-.32-6.8 2.28 1.3.06 2.69 1.03 2.6 2.26a5.04 5.04 0 0 1 3.5-1.34c-.61-.96-.3-2.63.7-3.2zM78.62 98.7c.7-2.59 2.7-4.64 5.77-4.73l1.99-.05c14.74-.44 27.97-5.76 37.44-16.86 1.3-1.58-.15-3.76-2.97-3.83h-.04c-.48.5-.57 1.4-1.36 2.75-2.88 4.91-6.86 7.16-12.17 9.76-16.3 7.96-24.74 4.26-28.13 9.13-.99 1.44-1 3.04-.53 3.83zm29.47-33.38c-1.56-1.1-1.61-3-2.46-11.86-.27-2.82-.76-6.46-2.52-8.79a2.42 2.42 0 0 0-1.61-.67c-1.12-.05-2.37 1.08-3.09 1.86a17.14 17.14 0 0 1-7.37 6.3 22.58 22.58 0 0 1-10.16 2c-2.5-.08-4.69-.49-6.83-.51-3.98-.06-7.42 1.2-9.93 4.31a12.18 12.18 0 0 0-2.64 7.07 23.19 23.19 0 0 0 .16 2.14c.18 1.36.43 2.06.43 2.06v.03l.06.2s-1.8-1.18-2.66-2.22c.86 5.31 5.12 9.09 6.52 10.2l.24.18.02.02.18.13c-.93.21-2.28.13-2.28.13.01 0 3.39 2.62 6.31 3.53a22.14 22.14 0 0 1 11.91-4.84 96.78 96.78 0 0 1 7.08-3.91c-.76-4.68 3.47-9.4 8.8-9.85 4.01-.29 5.97 1.48 7.38 3.37l2.58-.78a.8.8 0 0 1-.12-.1zm1.92 31.54a.8.8 0 0 0-.14.03c-1.61.36-18.16 6.65-28.63 3.43-.05.56-.03 1.74.2 2.25 1.59.32 3.6.52 5.92.52 13.77 0 23.7-6.15 22.65-6.23zM32.97 95.6h.01a3.87 3.87 0 0 0 1-3.31c-.31-1.7-2.28-2.05-3.58-3.37l-.06-.06-.06-.07a2.81 2.81 0 0 1-.74-2.08c.1-1.74 1.67-2.23 2.5-1.91 0 0 .96.22 1.72 1.25-.12-.34-.1-.89-.68-1.7-.97-1.35-3.19-2.71-6.33-2.06-.58.12-.25.05-.83.21a2.2 2.2 0 0 0-.24.08c-.18.08-.35.14-.5.22-.09.05-.56.26-1.13.68-3.53 4.47 2.45 12.59 8.92 12.12z"
          fill="#EABE8D"
        />
        <path
          d="M85 67.83c.3.43.37.75.25.88-.24.28-1.1-.1-2.36-.58-3.23-1.18-5.62-1.36-9.84.2-1.06.4-1.82.71-2.18.66-.6-.09-.02-1.15 1.27-2.18a9.8 9.8 0 0 1 9.23-1.55A7.95 7.95 0 0 1 85 67.83zm-.65 3.24a5.83 5.83 0 0 0-4.21-.83c-.36.06-.69.16-1.01.25l-.34.11c-.7.3-1.31.6-1.9 1.16-.68.64-.87 1.23-.67 1.38.19.15.66-.08 1.38-.36a11.82 11.82 0 0 1 5.77-.9c.79.05 1.31.1 1.44-.11.08-.15-.07-.42-.46-.7zM32.2 83.22c.4.31.7.64.93.96.74 1.03.5 1.63.81 1.93.11.1.27.13.43.07.42-.17.63-.83.67-1.28.1-1.11-.5-2.35-1.28-3.23a6.9 6.9 0 0 0-1.88-1.47 7.93 7.93 0 0 0-2.6-.88 10 10 0 0 0-3.77.2c-.24.08-.53.14-.78.23a8.47 8.47 0 0 0-5.32 5.48 9.36 9.36 0 0 0-.19 4.79 6.4 6.4 0 0 0 1.44 2.95c.92.98 1.93.8 1.5-.11-.1-.25-.66-1.28-.73-3.13A8.97 8.97 0 0 1 22 86.1a7 7 0 0 1 1.05-1.78c.93-1.1 2.06-1.6 2.2-1.67.16-.09.32-.14.5-.23l.24-.07c.58-.16.25-.1.83-.21a6.41 6.41 0 0 1 5.38 1.08zm-.47 4.12c-.3-.23-.44-.43-.52-.74-.12-.56-.06-.88.43-1.22.37-.25.68-.37.68-.53.02-.3-1.24-.6-2.12.24-.73.76-.96 2.35.2 3.58 1.3 1.37 3.31 1.7 3.63 3.41.04.25.07.52.05.79 0 .3-.1.75-.1.77-.4 1.67-2 3.25-4.67 2.85-.49-.07-.8-.13-.9 0-.2.28.94 1.56 3.02 1.5a5.18 5.18 0 0 0 4.71-3.77 5.65 5.65 0 0 0 .14-2.55c-.53-2.89-3.46-3.48-4.55-4.33zm71.09-20.59c-.8-.12-1.6.66-1.77 1.74-.18 1.08.34 2.06 1.14 2.18.81.12 1.6-.65 1.78-1.74.17-1.08-.34-2.05-1.15-2.18zm-8.86 3.16c-.44.79.1 1.91 1.2 2.5 1.12.6 2.37.44 2.82-.35.44-.8-.1-1.91-1.2-2.5-1.12-.6-2.37-.44-2.82.35zm-32.44-32c15.25-9.67 30.48-10.78 35.7-6.86a4.8 4.8 0 0 0-.12-.31c-1.33-2.76-4.42-4.68-7.17-5.45a10.6 10.6 0 0 1 1.46 1.92A22.2 22.2 0 0 0 83.67 24s.34.24.4.3a7.3 7.3 0 0 1 1.65 2.06c-2.75-1.09-6.24-1.7-9.22-1.13l-.37.08.47.12c.99.3 2.4.88 3.02 1.69-4.95-.85-10.4.09-13.33 1.7.38-.02.38-.02.7-.01 1.07.03 3.25.17 4.17.74-3.13.62-7.65 1.99-10.08 4.03.43-.05 2.87-.35 3.87-.2-13.4 7.5-19.49 18.84-19.49 18.84a62.56 62.56 0 0 1 16.06-14.3v-.01z"
          fill="#9C7356"
        />
        <path
          d="M98 58.9c-.02-.96.14-2.55 1.1-2.85 1.64-.54 3.8 3.43 3.9 6.95a8.6 8.6 0 0 0-4.37-.74c-.4-1.14-.58-2.2-.63-3.36z"
          fill="#684C46"
        />
      </g>
    </SVG>
  );
}

export class NextStepsShape extends UniqueComponent {
  render() {
    return (
      <SVG {...this.props} viewBox="0 0 1150 679">
        <defs>
          <linearGradient
            id={this.uniqueName('background-gradient')}
            x1="6.72%"
            x2="147.74%"
            y1="20.94%"
            y2="126.85%"
          >
            <stop offset="0%" stopColor="#D06BF2" />
            <stop offset="100%" stopColor="#3B96E5" />
          </linearGradient>
        </defs>
        <path
          d="M119.28 132.88c210.66-254.66 479.04 162.14 792.29-65.14 135.95-98.64 241.29 106.45 227.56 262.65-12.85 146.2-84.74 291.3-250.27 291.3-165.53 0-241.65-98.13-423.58 30.28C257.25 798.8 95.34 640.7 39.05 511.8c-99.52-227.9-41.88-231.3 80.23-378.92z"
          fill={this.uniqueUrl('background-gradient')}
          fillRule="evenodd"
          transform="rotate(10 564.33 376.44)"
        />
      </SVG>
    );
  }
}

export function Mouse(props) {
  let { color, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 90 140">
      <g fill={color}>
        <path d="M38.42 41h.16c4.6 0 8.42 3.7 8.42 8.19V72.8c0 4.5-3.8 8.2-8.42 8.2h-.16c-4.6 0-8.42-3.7-8.42-8.19V49.03c0-4.48 3.8-8.03 8.42-8.03z" />
        <path d="M0 48.75v52.3a38.9 38.9 0 0 0 11.27 27.31C18.62 135.81 28.32 140 38.5 140h.78A38.12 38.12 0 0 0 77 101.98V48.75C77 30.75 62.13 16 43.97 16h-11.1C14.87 16 0 30.74 0 48.75zm8.3 0c0-13.5 11.11-24.52 24.73-24.52h1.4v12.25c1.26-.46 2.66-.61 4.07-.61h.16c1.4 0 2.82.15 4.07.61V24.23h1.41c13.62 0 24.73 11.02 24.73 24.52v11.64H51.81v8.22h17.05v33.37c0 16.3-13.3 29.64-29.73 29.95h-.63a30.02 30.02 0 0 1-21.44-9.15 30.64 30.64 0 0 1-8.92-21.73V68.46H25.2v-8.22l-16.9-.01V48.75zm69.54-22.91l7.9-4.47c1.4-.77 3.11-.3 3.89 1.08a2.8 2.8 0 0 1-1.09 3.86l-7.75 4.47c-.78.47-1.86.16-2.33-.61-.3-.62-.77-1.24-1.08-1.85-.63-.78-.48-1.86.46-2.48zm-8.51-6.28c-.6-.45-1.05-.9-1.66-1.35a1.7 1.7 0 0 1-.3-2.42l5.72-6.78a2.69 2.69 0 0 1 3.9-.3 2.7 2.7 0 0 1 .3 3.92l-5.55 6.78c-.76.76-1.81.76-2.41.15zm-10.99-5.75c-.65-.32-1.46-.48-2.1-.8a1.73 1.73 0 0 1-1.14-2.25l3.24-8.84C58.82.32 60.6-.32 62.06.15c1.62.49 2.27 2.25 1.78 3.7l-3.23 8.84c-.33 1.12-1.46 1.6-2.27 1.12z" />
      </g>
    </SVG>
  );
}
Mouse.propTypes = {
  color: PropTypes.string,
};
Mouse.defaultProps = {
  color: 'currentColor',
};

export function Squiggle(props) {
  let { color, strokeWidth, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 74 293">
      <path
        d="M73.18 291.5c-36.71-5.28-59.84-53.15-66.84-74.24C-21.03 134.76 98.61 79.98 35.86 1.5"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </SVG>
  );
}
Squiggle.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};
Squiggle.defaultProps = {
  color: 'currentColor',
  strokeWidth: 3,
};

export function Arrow(props) {
  let { color, strokeWidth, strokeLinecap, ...otherProps } = props;

  return (
    <SVG {...otherProps} viewBox="0 0 33 29">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap={strokeLinecap}
      >
        <path d="M3.15 14.7H29.3M20.47 3.67l8.82 10.82M20.47 25.72l8.82-10.83" />
      </g>
    </SVG>
  );
}
Arrow.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.string,
};
Arrow.defaultProps = {
  color: '#9F58F7',
  strokeWidth: 3,
  strokeLinecap: 'round',
};

export function Circle(props) {
  let {
    radius,
    // fill,
    // stroke,
    // strokeWidth,
    // strokeLinecap,
    ...otherProps
  } = props;

  let pathProps = {};
  // if (fill !== undefined) {
  //   pathProps['fill'] = fill;
  // }
  // if (stroke !== undefined) {
  //   pathProps['stroke'] = stroke;
  // }
  // if (strokeWidth !== undefined) {
  //   pathProps['strokeWidth'] = strokeWidth;
  // }
  // if (strokeLinecap !== undefined) {
  //   pathProps['strokeLinecap'] = strokeLinecap;
  // }

  return (
    <SVG {...otherProps} viewBox={`0 0 ${radius * 2} ${radius * 2}`}>
      <path
        {...pathProps}
        d={`
          M ${radius} ${radius}
          m -${radius}, 0
          a ${radius},${radius} 0 1,1 ${radius * 2},0
          a ${radius},${radius} 0 1,1 -${radius * 2},0
          `}
      />
    </SVG>
  );
}
Circle.propTypes = {
  radius: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.string,
};
Circle.defaultProps = {
  radius: 50,
  fill: 'none',
  stroke: 'none',
  strokeWidth: 3,
  strokeLinecap: 'round',
};

export function LogoGoogleFonts(props) {
  return (
    <SVG {...props} viewBox={`0 0 1000 182`}>
      <path
        d="M135.93 64.29H71.65v19.07h45.59c-2.25 26.75-24.5 38.16-45.51 38.16-26.88 0-50.33-21.15-50.33-50.79 0-28.87 22.36-51.1 50.39-51.1 21.62 0 34.37 13.78 34.37 13.78l13.35-13.83S102.37.5 71.11.5C31.3.5.5 34.1.5 70.4c0 35.56 28.97 70.24 71.62 70.24 37.52 0 64.98-25.7 64.98-63.7 0-8.02-1.17-12.65-1.17-12.65z"
        fill="#4885ed"
      />
      <path
        d="M188.59 50.47c-26.38 0-45.28 20.62-45.28 44.67 0 24.41 18.34 45.41 45.59 45.41 24.67 0 44.88-18.85 44.88-44.88 0-29.83-23.5-45.2-45.19-45.2zm.26 17.7c12.97 0 25.26 10.48 25.26 27.38 0 16.54-12.24 27.32-25.32 27.32-14.37 0-25.71-11.5-25.71-27.45 0-15.6 11.2-27.25 25.77-27.25z"
        fill="#db3236"
      />
      <path
        d="M287.07 50.47c-26.38 0-45.28 20.62-45.28 44.67 0 24.41 18.33 45.41 45.59 45.41 24.67 0 44.88-18.85 44.88-44.88 0-29.83-23.51-45.2-45.2-45.2zm.26 17.7c12.97 0 25.26 10.48 25.26 27.38 0 16.54-12.24 27.32-25.32 27.32-14.38 0-25.72-11.5-25.72-27.45 0-15.6 11.2-27.25 25.78-27.25z"
        fill="#f4c20d"
      />
      <path
        d="M383.65 50.52c-24.21 0-43.24 21.2-43.24 45 0 27.12 22.06 45.1 42.82 45.1 12.84 0 19.66-5.1 24.7-10.95v8.88c0 15.54-9.43 24.84-23.67 24.84-13.76 0-20.66-10.22-23.06-16.03l-17.3 7.24c6.13 12.98 18.5 26.52 40.5 26.52 24.07 0 42.42-15.16 42.42-46.96V53.23h-18.89v7.63c-5.8-6.26-13.74-10.34-24.28-10.34zm1.75 17.66c11.87 0 24.06 10.13 24.06 27.44 0 17.6-12.16 27.29-24.32 27.29-12.9 0-24.92-10.48-24.92-27.12 0-17.3 12.48-27.61 25.18-27.61z"
        fill="#4885ed"
      />
      <path d="M439.98 137.91h19.84V5.16h-19.84z" fill="#3cba54" />
      <path
        d="M510.78 50.42c-22.84 0-42.01 18.16-42.01 44.97 0 28.37 21.37 45.2 44.2 45.2 19.06 0 30.75-10.43 37.73-19.77l-15.57-10.36c-4.04 6.27-10.79 12.4-22.06 12.4-12.66 0-18.49-6.93-22.1-13.65l60.4-25.06-3.13-7.34c-5.84-14.38-19.45-26.4-37.46-26.4zm.79 17.32c8.23 0 14.15 4.37 16.66 9.62L487.9 94.2c-1.74-13.05 10.63-26.47 23.67-26.47z"
        fill="#db3236"
      />
      <path
        d="M621.73 137.34h-15.48V16.9h70.32v14.8h-54.84v39.54h49.46V85.7h-49.46zm76.8-72.59c7.96-8.36 18.11-12.53 30.45-12.53s22.49 4.17 30.45 12.53c7.96 8.36 11.94 18.82 11.94 31.38 0 12.56-3.98 23.02-11.94 31.37-7.96 8.36-18.11 12.53-30.45 12.53s-22.49-4.17-30.45-12.53c-7.96-8.35-11.95-18.81-11.95-31.37 0-12.56 3.98-23.02 11.95-31.38zm11.52 53c5.33 5.43 11.64 8.15 18.93 8.15 7.29 0 13.6-2.72 18.92-8.16 5.33-5.44 8-12.64 8-21.62 0-8.97-2.67-16.17-8-21.61-5.32-5.44-11.63-8.16-18.92-8.16-7.3 0-13.6 2.72-18.93 8.16-5.33 5.44-8 12.64-8 21.61 0 8.98 2.67 16.18 8 21.63zm90.35-62.84v11.44h.67c2.25-3.93 5.78-7.26 10.6-10.01a30.76 30.76 0 0 1 15.48-4.12c10.2 0 18 3.14 23.38 9.42 5.38 6.28 8.08 14.69 8.08 25.24v50.46h-15.48V89.23c0-15.25-6.78-22.88-20.35-22.88-6.4 0-11.61 2.55-15.65 7.65a27.79 27.79 0 0 0-6.06 17.75v45.6H785.6V54.9zm112.2 83.78c-8.63 0-15.22-2.3-19.76-6.9-4.55-4.6-6.82-11.1-6.82-19.51V69.04h-14.47V54.9h14.47V29.67h15.48v25.24h20.19v14.13H901.5v42.06c0 8.97 3.7 13.46 11.1 13.46 2.8 0 5.16-.45 7.07-1.35l5.39 13.3c-3.37 1.45-7.52 2.18-12.45 2.18zm54.43 1.34c-9.2 0-16.8-2.24-22.8-6.72-6-4.49-10.4-10.1-13.2-16.83l13.8-5.72c4.37 10.32 11.83 15.48 22.37 15.48 4.82 0 8.78-1.07 11.86-3.2 3.09-2.13 4.63-4.93 4.63-8.41 0-5.38-3.76-9.03-11.28-10.94l-16.65-4.03A39.62 39.62 0 0 1 940.79 92c-4.71-3.75-7.07-8.83-7.07-15.22 0-7.29 3.23-13.2 9.68-17.75 6.44-4.54 14.1-6.81 22.96-6.81 7.29 0 13.8 1.65 19.51 4.96a27.99 27.99 0 0 1 12.28 14.22l-13.46 5.55c-3.02-7.3-9.3-10.94-18.84-10.94-4.6 0-8.46.95-11.6 2.86-3.14 1.9-4.71 4.49-4.71 7.74 0 4.71 3.64 7.9 10.93 9.6l16.32 3.86c7.74 1.8 13.46 4.88 17.16 9.25a22.32 22.32 0 0 1 5.55 14.8c0 7.41-3.03 13.58-9.08 18.51-6.06 4.94-13.86 7.4-23.39 7.4z"
        fill="#767676"
      />
    </SVG>
  );
}

export function LogoRebelGive(props) {
  return (
    <SVG {...props} viewBox={`0 0 631 201`}>
      <path
        d="M594.7 101.669h22.884l-.034-.268c-1.271-6.51-5.252-10.116-11.208-10.116-6.19 0-10.305 3.606-11.576 10.116l-.067.268zm11.71-21.47c14.486 0 24.289 10.385 24.322 25.877 0 1.469-.1 3.172-.234 4.307h-35.866l.067.267c1.372 6.745 6.056 10.484 13.182 10.484 4.383 0 9.134-1.736 12.747-4.674l7.695 8.314c-5.487 4.874-12.613 7.345-21.211 7.345-15.558 0-25.996-10.35-25.996-25.776 0-7.613 2.442-14.123 7.026-18.865 4.583-4.808 10.907-7.278 18.267-7.278zM568 82.538h13.852l-19.573 48.247h-15.39l-19.773-48.247h14.32l13.215 34.991 13.35-34.991zm-58.683 48.213V82.537h13.182v48.247h-13.182v-.034zm6.423-72.387c4.718 0 8.398 3.64 8.398 8.314 0 4.608-3.68 8.214-8.398 8.214-4.75 0-8.33-3.54-8.33-8.214s3.646-8.314 8.33-8.314zm-11.977 33.823v1.302c0 26.01-14.42 38.53-34.26 38.53-18.234 0-37.539-12.687-37.539-36.927 0-10.417 3.714-19.866 10.439-26.577 6.724-6.712 16.16-10.418 26.598-10.418 18.87 0 28.606 13.122 28.606 13.122l-9.803 9.716s-6.558-9.683-19.205-9.683c-13.249 0-22.483 9.817-22.483 23.84 0 7.078 2.242 13.155 6.491 17.562 4.048 4.174 10.506 6.478 16.628 6.478 11.074 0 18.301-5.142 20.275-16.027l.034-.233h-20.577V92.22l34.796-.034zm-96.59-31.619l13.181-3.138v73.321h-13.182V60.567zm-42.157 41.102h22.885l-.033-.268c-1.272-6.51-5.253-10.116-11.209-10.116-6.19 0-10.304 3.606-11.576 10.116l-.067.268zm11.71-21.47c14.487 0 24.29 10.385 24.324 25.877 0 1.469-.1 3.172-.235 4.307H364.95l.066.267c1.372 6.745 6.056 10.484 13.183 10.484 4.382 0 9.133-1.736 12.747-4.674l7.695 8.314c-5.487 4.874-12.614 7.345-21.212 7.345-15.558 0-25.996-10.35-25.996-25.776 0-7.613 2.442-14.123 7.026-18.865 4.583-4.808 10.907-7.278 18.267-7.278zm-70.36 25.91c0 8.047 5.554 13.89 13.182 13.89 7.796 0 13.25-5.71 13.25-13.89s-5.454-13.89-13.25-13.89c-7.628 0-13.182 5.844-13.182 13.89zm39.948 0c0 14.791-10.405 25.91-24.223 25.91-6.256 0-11.308-2.237-14.955-6.678l-.402-.467v5.876h-12.847V60.567l13.115-3.138v29.649l.368-.468c3.613-4.273 8.531-6.444 14.62-6.444 13.919.034 24.324 11.185 24.324 25.943zm-94.55-4.44h22.885l-.034-.268c-1.27-6.51-5.252-10.116-11.208-10.116-6.19 0-10.304 3.606-11.576 10.116l-.067.268zm11.71-21.47c14.487 0 24.29 10.385 24.324 25.877 0 1.469-.1 3.172-.235 4.307h-35.866l.067.267c1.372 6.745 6.056 10.484 13.182 10.484 4.383 0 9.134-1.736 12.748-4.674l7.695 8.314c-5.487 4.874-12.614 7.345-21.212 7.345-15.558 0-25.996-10.35-25.996-25.776 0-7.613 2.442-14.123 7.026-18.865 4.583-4.808 10.907-7.278 18.267-7.278zm-71.196-7.846V90.35h16.26c8.13 0 12.245-3.072 12.245-9.115 0-5.877-4.115-8.882-12.245-8.882h-16.26zm26.732 58.564l-19.54-28.547h-7.192v28.547h-14.12V59.6h30.647c17.097 0 26.532 7.68 26.532 21.636 0 11.352-8.23 20.166-19.572 20.968l-.368.033 19.84 28.714H219.01v-.033zM75.88 201L2.376 111.752A10.249 10.249 0 0 1 1.037 100.7c1.74-3.639 5.454-5.943 9.535-5.976l93.446-.4c3.078-.068 6.09 1.335 8.097 3.638a10.246 10.246 0 0 1 2.408 8.448l-5.453 33.656 29.71 18.13-11.141 17.762-35.732-21.769a10.363 10.363 0 0 1-4.885-10.517l4.583-28.347-58.817.2L92.34 187.81 75.881 201zM57.079 82.77C34.16 82.77 15.59 64.24 15.59 41.37 15.591 18.497 34.16 0 57.078 0c22.918 0 41.486 18.53 41.486 41.402 0 22.871-18.602 41.369-41.486 41.369zm.167-22.17c10.706 0 19.405-8.68 19.405-19.365 0-10.684-8.699-19.365-19.405-19.365-10.706 0-19.405 8.68-19.405 19.365 0 10.684 8.665 19.365 19.405 19.365z"
        fill="#00B9E5"
        fillRule="nonzero"
      />
    </SVG>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/SVG.js